import { useEffect, useState } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import {
    ArrowLeftIcon,
    ArrowRightIcon,
    MagnifyingGlassIcon,
    EllipsisVerticalIcon,
    EyeIcon,
    TicketIcon,
    PencilIcon,
} from '@heroicons/react/20/solid'
import { Badge } from 'components/badge'
import { Divider } from 'components/divider'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'components/table'
import { Input, InputGroup } from 'components/input'
import { Select } from 'components/select'
import { useMutation } from '@apollo/client'
import { TrashIcon } from '@heroicons/react/20/solid'
import { GraphQlResponseNoData } from 'components/custom/GraphQlResponseDisplay'
import { Dialog, DialogPanel, DialogTitle, DialogBackdrop } from '@headlessui/react'
import { XMarkIcon, CheckIcon } from '@heroicons/react/24/outline'
import { REMOVE_MEAL_FROM_TRIP } from 'graphql/meals/mutations'

import { GET_MEAL_DETAILS_FROM_TRIP, MEAL_STATUS } from 'graphql/meals/queries'
import { SEARCH_MEAL } from 'graphql/meals/queries'
import { ADD_MEAL_TO_TRIP, UPDATE_MEAL_ORDER_STATUS } from 'graphql/meals/mutations'

import {
    Dropdown,
    DropdownButton,
    DropdownDivider,
    DropdownItem,
    DropdownLabel,
    DropdownMenu,
} from 'components/dropdown'

import { useLazyQuery } from '@apollo/client'
import { GET_BOAT_ROUTE, GET_BOAT_ROUTE_WITH_TRIP_DETAILS } from 'graphql/route/queries'
import { ErrorDialog, SuccessDialog } from 'components/custom/ResponseDialog'
import { BoatRouteTripStatusDropdown } from 'components/custom/RouteTripStatusDropdown'
import loadingImage from 'assets/images/boat-loading.gif'
import {
    UPDATE_BOAT_ROUTE_PRICE,
    UPDATE_BOAT_ROUTE_LUGGAGE_PRICE,
    UPDATE_BOAT_ROUTE_SERVICE_FEE,
} from 'graphql/route/mutations'
import { UPDATE_CHARTER_BOAT_ROUTE_PRICE } from 'graphql/charterBoats/mutations'
import { customTimeFormat, customDateFormat } from 'utils/common'
import { CaptainIcon } from 'components/icons'
import TripAlert from '../TripAlert'
import { GET_ROUTE_SHUTTLE_SERVICES, SEARCH_SHUTTLE_SERVICE_PROVIDER } from 'graphql/shuttleService/queries'
import { ADD_SHUTTLE_SERVICE_TO_ROUTE, ENABLE_DISABLE_SHUTTLE_SERVICE_PROVIDER } from 'graphql/shuttleService/mutations'
import { GET_LUGGAGE_DETAILS_FROM_TRIP_BY_TRIP_ID, SEARCH_LUGGAGE } from 'graphql/luggages/queries'
import { ADD_LUGGAGE_TO_TRIP, ENABLE_DISABLE_LUGGAGE_IN_TRIP } from 'graphql/luggages/mutations'

const tabs = [
    { name: 'Schedule', key: 'trips' },
    { name: 'Pricing', key: 'pricing' },
    { name: 'Service Fees', key: 'service fees' },
    { name: 'Meals', key: 'meals' },
    { name: 'Luggages', key: 'luggage' },
    { name: 'Shuttle Service', key: 'shuttle' },

    // { name: 'Assign Boat', key: 'assignboat' },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function MetroRouteDetails() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { t } = useTranslation()
    const { id } = useParams()
    // Get state object from the URL
    const { navBackTab } = state || {}
    const [searchString, setSearchString] = useState('')
    // Dialog Message
    const [showErrDialog, setShowErrDialog] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [submitLoading, setSubmitLoading] = useState(false)
    const [showSucDialog, setShowSucDialog] = useState(false)

    const [searchTripStatus, setTripSearchStatus] = useState('All')
    const [filterTripList, setFilterTripList] = useState(null)
    const [tripList, setTripList] = useState(null)
    const [routePriceList, setRoutePriceList] = useState([])
    //
    const [routeList, setRouteList] = useState(null)

    const [mealList, setMealList] = useState([])
    const [luggageList, setLuggageList] = useState([])
    const [allMealsList, setAllMealsList] = useState([])
    const [allLuggagesList, setAllLuggagesList] = useState([])
    const [showMealModal, setShowMealModal] = useState(false)
    const [selectedMealId, setSelectedMealId] = useState('')
    const [selectedLuggageId, setSelectedLuggageId] = useState('')
    const [mealSearchString, setMealSearchString] = useState('')
    const [luggageSearchString, setLuggageSearchString] = useState('')
    const [mealPage, setMealPage] = useState(0)
    const [luggagePage, setLuggagePage] = useState(0)
    const [mealRowsPerPage, setMealRowsPerPage] = useState(10)
    const [luggageRowsPerPage, setLuggageRowsPerPage] = useState(10)
    const [showOnlyAvailable, setShowOnlyAvailable] = useState(false)
    const [mealStatuses, setMealStatuses] = useState([])
    const [mealStatusUpdateLoading, setMealStatusUpdateLoading] = useState(false)

    // Luggage and special needs state
    const [luggagePrices, setLuggagePrices] = useState({})
    const [strollersPrice, setStrollersPrice] = useState(0)
    const [wheelchairsPrice, setWheelchairsPrice] = useState(0)
    const [luggageUpdateLoading, setLuggageUpdateLoading] = useState(false)
    const [showLuggageModal, setShowLuggageModal] = useState(false)

    // Shuttle service state
    const [shuttleServiceList, setShuttleServiceList] = useState([])
    const [allShuttleServices, setAllShuttleServices] = useState([])
    const [showShuttleModal, setShowShuttleModal] = useState(false)
    const [selectedShuttleId, setSelectedShuttleId] = useState('')
    const [shuttleSearchString, setShuttleSearchString] = useState('')
    const [shuttlePage, setShuttlePage] = useState(0)
    const [shuttleRowsPerPage, setShuttleRowsPerPage] = useState(10)
    const [showShuttleConfirmDialog, setShowShuttleConfirmDialog] = useState(false)
    const [shuttleToToggle, setShuttleToToggle] = useState(null)
    const [serviceFeesList, setServiceFeesList] = useState([])

    // const [routeCount, setRouteCount] = useState(0)
    const [activeTab, setActiveTab] = useState(navBackTab ? navBackTab : 'trips')

    const [getRouteList, { loading: routeListLoading, error: routeListError }] = useLazyQuery(
        GET_BOAT_ROUTE_WITH_TRIP_DETAILS,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data.getBoatRoute.success && data.getBoatRoute.code === '200') {
                    setRouteList(data.getBoatRoute.boat_routes)
                    // setRouteCount(data.getBoatRoute.length)
                    setTripList(data.getBoatRoute.boat_routes[0].route_trip)
                    setFilterTripList(data.getBoatRoute.boat_routes[0].route_trip)
                    setRoutePriceList(data.getBoatRoute.boat_routes[0].route_price)

                    // Initialize luggage prices from weight_config (if available)
                    const weightConfig = data.getBoatRoute.boat_routes[0]?.weight_config
                    if (weightConfig && weightConfig.luggage_policy) {
                        const luggagePolicy = weightConfig.luggage_policy

                        // Initialize extra luggage options prices
                        const luggagePricesObj = {}
                        if (luggagePolicy.extra_luggage_options_kg) {
                            // extra_luggage_options_kg is an array of weight values (numbers)
                            luggagePolicy.extra_luggage_options_kg.forEach(weightKg => {
                                luggagePricesObj[weightKg] = 0 // Initialize with 0, will be updated if there are existing prices
                            })
                        }
                        setLuggagePrices(luggagePricesObj)

                        // Initialize strollers and wheelchairs prices (these are not in the query response, will be set via mutation)
                        setStrollersPrice(0)
                        setWheelchairsPrice(0)
                    } else {
                        // Initialize with default values if weight_config is not available
                        setLuggagePrices({})
                        setStrollersPrice(0)
                        setWheelchairsPrice(0)
                    }
                }
            },
        }
    )
    useEffect(() => {
        searchBoatsRoutes()
    }, [id])

    const handleBack = () => {
        navigate('/metro-routes')
    }

    // Helper function to determine if round trip pricing should be shown
    // Round trip price is applicable for international trips and 2-waypoint domestic trips
    // const shouldShowRoundTripPricing = () => {
    //     if (!routeList || routeList.length === 0) return false
    //
    //     const route = routeList[0]
    //     const routeType = route?.master_route?.route_type?.code
    //     const waypoints = route?.master_route?.waypoints || []
    //
    //     // Show for international routes (INL)
    //     if (routeType === 'INL') {
    //         return true
    //     }
    //
    //     // Show for domestic routes (DMC) with exactly 2 waypoints
    //     if (routeType === 'DMC' && waypoints.length === 2) {
    //         return true
    //     }
    //
    //     return false
    // }

    const [getTripMeals, { loading: tripMealsLoading, error: tripMealsError }] = useLazyQuery(
        GET_MEAL_DETAILS_FROM_TRIP,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data.getMealDetailsFromTripByTripId.success && data.getMealDetailsFromTripByTripId.code === '200') {
                    setMealList(data.getMealDetailsFromTripByTripId.trip_meals)
                }
            },
        }
    )

    const [getTripLuggages, { loading: tripLuggagesLoading, error: tripLuggagesError }] = useLazyQuery(
        GET_LUGGAGE_DETAILS_FROM_TRIP_BY_TRIP_ID,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (
                    data.getLuggageDetailsFromTripByTripId.success &&
                    data.getLuggageDetailsFromTripByTripId.code === '200'
                ) {
                    setLuggageList(data.getLuggageDetailsFromTripByTripId.trip_luggages)
                }
            },
        }
    )

    const [searchAllMeals, { loading: allMealsLoading, error: allMealsError }] = useLazyQuery(SEARCH_MEAL, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: data => {
            if (data.searchMeal.success && data.searchMeal.code === '200') {
                setAllMealsList(data.searchMeal.meals)
            }
        },
    })

    const [searchAllLuggages, { loading: allLuggagesLoading, error: allLuggagesError }] = useLazyQuery(SEARCH_LUGGAGE, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: data => {
            if (data.searchLuggage.success && data.searchLuggage.code === '200') {
                setAllLuggagesList(data.searchLuggage.luggages)
                console.log()
            }
        },
    })

    const [getMealStatuses, { loading: mealStatusLoading, error: mealStatusError }] = useLazyQuery(MEAL_STATUS, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: data => {
            if (data.mealStatus) {
                setMealStatuses(data.mealStatus)
            }
        },
    })

    const [searchAllShuttleServices, { loading: allShuttleServicesLoading, error: allShuttleServicesError }] =
        useLazyQuery(SEARCH_SHUTTLE_SERVICE_PROVIDER, {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data.searchShuttleServiceProvider.success && data.searchShuttleServiceProvider.code === '200') {
                    setAllShuttleServices(data.searchShuttleServiceProvider.providers)
                }
            },
        })

    const [getRouteShuttleServices, { loading: routeShuttleServicesLoading, error: routeShuttleServicesError }] =
        useLazyQuery(GET_ROUTE_SHUTTLE_SERVICES, {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (
                    data.getShuttleDetailsFromRouteByRouteId.success &&
                    data.getShuttleDetailsFromRouteByRouteId.code === '200'
                ) {
                    setShuttleServiceList(data.getShuttleDetailsFromRouteByRouteId.route_shuttles || [])
                }
            },
        })

    const [addMealToTrip, { loading: addMealLoading }] = useMutation(ADD_MEAL_TO_TRIP, {
        onCompleted: data => {
            console.log('addMealToTrip onCompleted:', data)
            if (data.addMealToTrip.success && data.addMealToTrip.code === '200') {
                setShowSucDialog(true)
                setShowMealModal(false)
                setSelectedMealId('')
                setMealSearchString('')
                searchTripMeals()
                setTimeout(() => {
                    setShowSucDialog(false)
                }, 1500)
            } else {
                console.error('addMealToTrip failed:', data.addMealToTrip.message)
                setErrorMessage(data.addMealToTrip.message)
                setShowErrDialog(true)
            }
        },
        onError: error => {
            console.error('addMealToTrip error:', error)
            setErrorMessage(error.message)
            setShowErrDialog(true)
        },
    })

    const [addLuggageToTrip, { loading: addLuggageLoading }] = useMutation(ADD_LUGGAGE_TO_TRIP, {
        onCompleted: data => {
            console.log('addLuggageToTrip onCompleted:', data)
            if (data.addLuggageToTrip.success && data.addLuggageToTrip.code === '200') {
                setShowSucDialog(true)
                setShowLuggageModal(false)
                setSelectedLuggageId('')
                setLuggageSearchString('')
                searchTripLuggages()
                setTimeout(() => {
                    setShowSucDialog(false)
                }, 1500)
            } else {
                console.error('addLuggageToTrip failed:', data.addLuggageToTrip.message)
                setErrorMessage(data.addLuggageToTrip.message)
                setShowErrDialog(true)
            }
        },
        onError: error => {
            console.error('addLuggageToTrip error:', error)
            setErrorMessage(error.message)
            setShowErrDialog(true)
        },
    })

    const [updateMealOrderStatus, { loading: updateMealStatusLoading }] = useMutation(UPDATE_MEAL_ORDER_STATUS, {
        onCompleted: data => {
            console.log('Meal status update response:', data)
            if (data.updateMealOrderStatus.success && data.updateMealOrderStatus.code === '200') {
                setMealStatusUpdateLoading(false)
                setShowSucDialog(true)
                // Refresh the meal data to get updated status
                searchTripMeals()
                setTimeout(() => {
                    setShowSucDialog(false)
                }, 1500)
            } else {
                setMealStatusUpdateLoading(false)
                setErrorMessage(data.updateMealOrderStatus.message || 'Failed to update meal status')
                setShowErrDialog(true)
            }
        },
        onError: error => {
            console.error('Meal status update error:', error)
            setMealStatusUpdateLoading(false)
            setErrorMessage(error.message || 'An error occurred while updating meal status')
            setShowErrDialog(true)
        },
    })

    const [addShuttleServiceToRoute, { loading: addShuttleLoading }] = useMutation(ADD_SHUTTLE_SERVICE_TO_ROUTE, {
        onCompleted: data => {
            console.log('addShuttleServiceToRoute onCompleted:', data)
            if (data.addShuttleServiceToRoute.success && data.addShuttleServiceToRoute.code === '200') {
                setShowSucDialog(true)
                setShowShuttleModal(false)
                setSelectedShuttleId('')
                setShuttleSearchString('')
                // Refresh the shuttle service data
                searchRouteShuttleServices()
                setTimeout(() => {
                    setShowSucDialog(false)
                }, 1500)
            } else {
                console.error('addShuttleServiceToRoute failed:', data.addShuttleServiceToRoute.message)
                // Close any existing success dialogs first
                setShowSucDialog(false)
                // Set error message and show error dialog
                setErrorMessage(data.addShuttleServiceToRoute.message || 'Failed to add shuttle service to route')
                setShowErrDialog(true)
                // Close the shuttle modal
                setShowShuttleModal(false)
            }
        },
        onError: error => {
            console.error('addShuttleServiceToRoute error:', error)
            // Close any existing success dialogs first
            setShowSucDialog(false)
            // Set error message and show error dialog
            setErrorMessage(error.message || 'An error occurred while adding shuttle service')
            setShowErrDialog(true)
            // Close the shuttle modal
            setShowShuttleModal(false)
        },
    })

    const [enableDisableShuttleService, { loading: toggleShuttleLoading }] = useMutation(
        ENABLE_DISABLE_SHUTTLE_SERVICE_PROVIDER,
        {
            onCompleted: data => {
                console.log('enableDisableShuttleService onCompleted:', data)
                if (
                    data.enableDisableShuttleServiceProvider.success &&
                    data.enableDisableShuttleServiceProvider.code === '200'
                ) {
                    setShowSucDialog(true)
                    setShowShuttleConfirmDialog(false)
                    setShuttleToToggle(null)
                    // Refresh the shuttle service data
                    searchRouteShuttleServices()
                    setTimeout(() => {
                        setShowSucDialog(false)
                    }, 1500)
                } else {
                    console.error(
                        'enableDisableShuttleService failed:',
                        data.enableDisableShuttleServiceProvider.message
                    )
                    // Close any existing success dialogs first
                    setShowSucDialog(false)
                    // Set error message and show error dialog
                    setErrorMessage(
                        data.enableDisableShuttleServiceProvider.message || 'Failed to update shuttle service status'
                    )
                    setShowErrDialog(true)
                    setShowShuttleConfirmDialog(false)
                    setShuttleToToggle(null)
                }
            },
            onError: error => {
                console.error('enableDisableShuttleService error:', error)
                // Close any existing success dialogs first
                setShowSucDialog(false)
                // Set error message and show error dialog
                setErrorMessage(error.message || 'An error occurred while updating shuttle service status')
                setShowErrDialog(true)
                setShowShuttleConfirmDialog(false)
                setShuttleToToggle(null)
            },
        }
    )

    const searchTripMeals = () => {
        if (routeList && routeList.length > 0 && routeList[0].route_trip && routeList[0].route_trip.length > 0) {
            const tripId = routeList[0].route_trip[0].trip_id
            getTripMeals({
                variables: {
                    page: {
                        limit: 10,
                        offset: 0,
                    },
                    tripId: tripId,
                },
            })
        }
    }

    const searchTripLuggages = () => {
        if (routeList && routeList.length > 0 && routeList[0].route_trip && routeList[0].route_trip.length > 0) {
            const tripId = routeList[0].route_trip[0].trip_id
            getTripLuggages({
                variables: {
                    page: {
                        limit: 10,
                        offset: 0,
                    },
                    trip_id: tripId,
                },
            })
        }
    }

    const [removeMealFromTrip, { loading: removeMealLoading }] = useMutation(REMOVE_MEAL_FROM_TRIP, {
        onCompleted: data => {
            if (data.removeMealFromTrip.success && data.removeMealFromTrip.code === '200') {
                setShowSucDialog(true)
                searchTripMeals()
                setTimeout(() => {
                    setShowSucDialog(false)
                }, 1500)
            } else {
                setErrorMessage(data.removeMealFromTrip.message)
                setShowErrDialog(true)
            }
        },
        onError: error => {
            setErrorMessage(error.message)
            setShowErrDialog(true)
        },
    })

    const [enableDisableLuggageInTrip, { loading: enableDisableLuggageLoading }] = useMutation(
        ENABLE_DISABLE_LUGGAGE_IN_TRIP,
        {
            onCompleted: data => {
                if (data.enableDisableLuggageInTrip.success && data.enableDisableLuggageInTrip.code === '200') {
                    setShowSucDialog(true)
                    searchTripLuggages()
                    setTimeout(() => {
                        setShowSucDialog(false)
                    }, 1500)
                } else {
                    setErrorMessage(data.enableDisableLuggageInTrip.message)
                    setShowErrDialog(true)
                }
            },
            onError: error => {
                setErrorMessage(error.message)
                setShowErrDialog(true)
            },
        }
    )

    const [getBoatRoutes, { loading: serviceFeesLoading, error: servicesFeesError }] = useLazyQuery(GET_BOAT_ROUTE, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: data => {
            if (data.getBoatRoute?.success && data.getBoatRoute?.code === '200') {
                setServiceFeesList(
                    data.getBoatRoute.boat_routes?.map(route => ({
                        route_id: route.route_id,
                        service_fee_config: route.service_fee_config || {},
                    })) || []
                )
            } else {
                setServiceFeesList([])
            }
        },
    })

    const searchAllMealsForModal = () => {
        searchAllMeals({
            variables: {
                page: {
                    limit: mealRowsPerPage,
                    offset: mealPage * mealRowsPerPage,
                },
                searchMealId: mealSearchString || null,
                statusCode: null,
                name: null,
            },
        })
    }

    const searchAllShuttleServicesForModal = () => {
        searchAllShuttleServices({
            variables: {
                page: {
                    limit: shuttleRowsPerPage,
                    offset: shuttlePage * shuttleRowsPerPage,
                },
                isactive: true, // Only get active shuttle services
                countryCode: null,
                name: shuttleSearchString || null,
                searchShuttleServiceProviderId: null,
            },
        })
    }

    const searchRouteShuttleServices = () => {
        if (id) {
            getRouteShuttleServices({
                variables: {
                    route_id: id,
                    page: {
                        limit: 100,
                        offset: 0,
                    },
                },
            })
        }
    }
    const handleAddMeal = () => {
        console.log('handleAddMeal called, selectedMealId:', selectedMealId)
        console.log('routeList:', routeList)

        if (!selectedMealId) {
            setErrorMessage('Please select a meal to add')
            setShowErrDialog(true)
            return
        }

        if (routeList && routeList.length > 0 && routeList[0].route_trip && routeList[0].route_trip.length > 0) {
            const tripId = routeList[0].route_trip[0].trip_id
            console.log('Adding meal to trip:', { tripId, selectedMealId })

            addMealToTrip({
                variables: {
                    meal_details: {
                        trip_id: tripId,
                        meal_id: selectedMealId,
                    },
                },
            })
        } else {
            console.error('No trip found in routeList')
            setErrorMessage('No trip found to add meal to')
            setShowErrDialog(true)
        }
    }

    const handleAddLuggage = () => {
        console.log('handleAddLuggage called, selectedLuggageId:', selectedLuggageId)
        console.log('routeList:', routeList)

        if (!selectedLuggageId) {
            setErrorMessage('Please select a luggage to add')
            setShowErrDialog(true)
            return
        }

        if (routeList && routeList.length > 0 && routeList[0].route_trip && routeList[0].route_trip.length > 0) {
            const tripId = routeList[0].route_trip[0].trip_id
            console.log('Adding luggage to trip:', { tripId, selectedLuggageId })

            addLuggageToTrip({
                variables: {
                    luggage_details: {
                        trip_id: tripId,
                        luggage_id: selectedLuggageId,
                    },
                },
            })
        } else {
            console.error('No trip found in routeList')
            setErrorMessage('No trip found to add luggage to')
            setShowErrDialog(true)
        }
    }

    const handleRemoveMeal = tripMealId => {
        removeMealFromTrip({
            variables: {
                tripMealId: tripMealId,
            },
        })
    }

    const handleEnableLuggage = tripLuggageId => {
        enableDisableLuggageInTrip({
            variables: {
                trip_luggage_id: tripLuggageId,
                isactive: true,
            },
        })
    }

    const handleDisableLuggage = tripLuggageId => {
        enableDisableLuggageInTrip({
            variables: {
                trip_luggage_id: tripLuggageId,
                isactive: false,
            },
        })
    }

    const getSelectableMeals = () => {
        if (!allMealsList || !mealList) return []

        const addedMealIds = new Set(mealList.map(tripMeal => tripMeal.meal_detail.meal_id))

        return allMealsList.filter(meal => !addedMealIds.has(meal.meal_id))
    }

    const getSelectableLuggages = () => {
        if (!allLuggagesList || !luggageList) return []

        const addedLuggageIds = new Set(luggageList.map(tripLuggage => tripLuggage.luggage_detail.luggage_id))

        return allLuggagesList.filter(luggage => !addedLuggageIds.has(luggage.luggage_id))
    }

    const searchAllLuggagesForModal = () => {
        searchAllLuggages({
            variables: {
                page: {
                    limit: luggageRowsPerPage,
                    offset: luggagePage * luggageRowsPerPage,
                },
                search_string: luggageSearchString || null,
            },
        })
    }

    const onLuggageSearch = () => {
        setLuggagePage(0)
        searchAllLuggagesForModal()
    }

    const onLuggageSearchClear = () => {
        setLuggageSearchString('')
        setLuggagePage(0)
        searchAllLuggagesForModal()
    }

    const onMealSearch = () => {
        setMealPage(0)
        searchAllMealsForModal()
    }

    const onMealSearchClear = () => {
        setMealSearchString('')
        setMealPage(0)
        searchAllMealsForModal()
    }

    const handleAddShuttleService = () => {
        console.log('handleAddShuttleService called, selectedShuttleId:', selectedShuttleId)

        if (!selectedShuttleId) {
            setErrorMessage('Please select a shuttle service to add')
            setShowErrDialog(true)
            return
        }

        addShuttleServiceToRoute({
            variables: {
                shuttleDetails: {
                    route_id: id,
                    provider_id: selectedShuttleId,
                    isactive: true,
                },
            },
        })
    }

    const handleToggleShuttleService = (providerId, currentStatus) => {
        console.log('handleToggleShuttleService called, providerId:', providerId, 'currentStatus:', currentStatus)
        setShuttleToToggle({ providerId, newStatus: !currentStatus })
        setShowShuttleConfirmDialog(true)
    }

    const confirmToggleShuttleService = () => {
        if (!shuttleToToggle) return

        enableDisableShuttleService({
            variables: {
                provider_id: shuttleToToggle.providerId,
                isactive: shuttleToToggle.newStatus,
            },
        })
    }

    const getSelectableShuttleServices = () => {
        if (!allShuttleServices || !shuttleServiceList) return []

        const addedShuttleIds = new Set(
            shuttleServiceList.map(routeShuttle => routeShuttle.shuttle_provider.provider_id)
        )

        return allShuttleServices.filter(shuttle => !addedShuttleIds.has(shuttle.provider_id))
    }

    const onShuttleSearch = () => {
        setShuttlePage(0)
        searchAllShuttleServicesForModal()
    }

    const onShuttleSearchClear = () => {
        setShuttleSearchString('')
        setShuttlePage(0)
        searchAllShuttleServicesForModal()
    }

    useEffect(() => {
        if (activeTab === 'meals' && routeList && routeList.length > 0) {
            searchTripMeals()
        }
    }, [activeTab, routeList])

    useEffect(() => {
        if (activeTab === 'luggage' && routeList && routeList.length > 0) {
            searchTripLuggages()
        }
    }, [activeTab, routeList])

    useEffect(() => {
        if (activeTab === 'shuttle' && routeList && routeList.length > 0) {
            searchRouteShuttleServices()
        }
    }, [activeTab, routeList])

    useEffect(() => {
        if (activeTab === 'service fees') {
            getBoatRoutes({
                variables: {
                    page: {
                        limit: 10,
                        offset: 0,
                    },
                    statusCode: null,
                    routeName: null,
                    routeId: null,
                },
            })
        }
    }, [activeTab])

    useEffect(() => {
        if (showMealModal) {
            searchAllMealsForModal()
        }
    }, [showMealModal, mealPage, mealRowsPerPage])

    useEffect(() => {
        if (showLuggageModal) {
            searchAllLuggagesForModal()
        }
    }, [showLuggageModal, luggagePage, luggageRowsPerPage])

    useEffect(() => {
        if (showShuttleModal) {
            searchAllShuttleServicesForModal()
        }
    }, [showShuttleModal, shuttlePage, shuttleRowsPerPage])

    const searchBoatsRoutes = () => {
        getRouteList({
            variables: {
                page: {
                    limit: 1,
                    offset: 0,
                },
                routeId: id,
                routeName: null,
            },
        })
    }
    const handleErrClose = () => {
        setShowErrDialog(false)
        setErrorMessage('')
    }
    const handleRouteTripStatusChange = e => {
        setTripSearchStatus(e.target.value)
    }

    const isMealAlreadyAdded = mealId => {
        return mealList.some(tripMeal => tripMeal.meal_detail.meal_id === mealId)
    }

    const onClickSearch = () => {
        if (searchTripStatus !== 'All' && (searchString !== '' || searchTripStatus)) {
            const searchList = tripList.filter(trip => {
                const matchesName = trip.trip_name.en.toLowerCase().includes(searchString.toLowerCase())
                const matchesStatus = searchTripStatus ? trip.status.code === searchTripStatus : true
                return matchesName && matchesStatus
            })
            setFilterTripList(searchList)
        } else if (searchTripStatus === 'All') {
            const searchList = tripList.filter(trip => {
                return trip.trip_name.en.toLowerCase().includes(searchString.toLowerCase())
            })
            setFilterTripList(searchList)
        } else {
            setFilterTripList(tripList)
        }
    }
    const onClickSearchClear = () => {
        setSearchString('')
        setTripSearchStatus('All')
        setFilterTripList(tripList)
    }

    const handleSuccessDialogClose = () => {
        setShowSucDialog(false)
    }

    const handleDialogClose = () => {
        setShowSucDialog(false)
        setShowErrDialog(false)
    }

    const [updateLuggagePrice, { loading: updateLuggageLoading }] = useMutation(UPDATE_BOAT_ROUTE_LUGGAGE_PRICE, {
        onCompleted: data => {
            console.log('Luggage price update response:', data)
            if (data.updateBoatRouteLuggagePrice.success && data.updateBoatRouteLuggagePrice.code === '200') {
                setLuggageUpdateLoading(false)
                setShowSucDialog(true)
                // Refresh the route data to get updated prices
                searchBoatsRoutes()
                setTimeout(() => {
                    setShowSucDialog(false)
                }, 1500)
            } else {
                setLuggageUpdateLoading(false)
                setErrorMessage(data.updateBoatRouteLuggagePrice.message || 'Failed to update luggage prices')
                setShowErrDialog(true)
            }
        },
        onError: error => {
            console.error('Luggage price update error:', error)
            setLuggageUpdateLoading(false)
            setErrorMessage(error.message || 'An error occurred while updating luggage prices')
            setShowErrDialog(true)
        },
    })

    const handleLuggagePriceUpdate = () => {
        setLuggageUpdateLoading(true)

        // Prepare the luggage price data according to the API specification
        const extraLuggagePriceConfig = {
            extra_luggage: Object.keys(luggagePrices).map(weightLimit => ({
                weight_kg: parseInt(weightLimit),
                price: parseFloat(luggagePrices[weightLimit]) || 0,
            })),
            special_items: {
                stroller_price: parseFloat(strollersPrice) || 0,
                wheelchair_price: parseFloat(wheelchairsPrice) || 0,
            },
        }

        // Debug log to verify the data structure
        console.log('Sending luggage price update:', {
            routeId: id,
            extraLuggagePriceConfig: extraLuggagePriceConfig,
        })

        updateLuggagePrice({
            variables: {
                routeId: id,
                extraLuggagePriceConfig: extraLuggagePriceConfig,
            },
        })
    }

    useEffect(() => {
        searchBoatsRoutes()
        // Load meal statuses when component mounts
        getMealStatuses({
            variables: {
                code: null,
            },
        })
    }, [id])

    const handleMealStatusUpdate = (tripId, mealId, orderStatus, travelDate) => {
        setMealStatusUpdateLoading(true)

        const orderDetails = {
            trip_id: tripId,
            meal_id: mealId,
            order_status: orderStatus,
            travel_date: travelDate,
        }

        console.log('Updating meal status:', orderDetails)

        updateMealOrderStatus({
            variables: {
                orderDetails: orderDetails,
            },
        })
    }

    const priceFormValidation = useFormik({
        enableReinitialize: true,
        initialValues: {
            stops: Object.values(
                routePriceList.reduce((acc, priceInfo) => {
                    const key = `${priceInfo.start_location.id}_${priceInfo.end_location.id}`

                    if (!acc[key]) {
                        const charterPrice = routeList?.[0]?.charter_route_price?.find(
                            charter =>
                                charter.start_location_id === priceInfo.start_location.id &&
                                charter.end_location_id === priceInfo.end_location.id
                        )

                        acc[key] = {
                            start_location_id: priceInfo.start_location.id,
                            start_location_name: priceInfo.start_location.name.en,
                            end_location_id: priceInfo.end_location.id,
                            end_location_name: priceInfo.end_location.name.en,
                            tickets: [],
                            charter_price: charterPrice?.price?.boat_price ?? '',
                            // charter_round_trip_price: charterPrice?.price?.round_trip?.boat_price ?? '',
                        }
                    }

                    if (priceInfo.seat_type.description.en !== 'Standard and VIP') {
                    acc[key].tickets.push({
                        seat_type_name: priceInfo.seat_type.description.en,
                        seat_type_code: priceInfo.seat_type.code,
                        price_id: priceInfo.price_id,
                        prices: {
                            ADL: priceInfo.price?.ADL ?? (priceInfo.price?.ADL === 0 ? 0 : ''),
                            CHD: priceInfo.price?.CHD ?? (priceInfo.price?.CHD === 0 ? 0 : ''),
                            INF: priceInfo.price?.INF ?? (priceInfo.price?.INF === 0 ? 0 : ''),
                            SNR: priceInfo.price?.SNR ?? (priceInfo.price?.SNR === 0 ? 0 : ''),
                        },
                        // round_trip_prices: {
                        //     ADL: priceInfo.price?.round_trip?.ADL ?? (priceInfo.price?.round_trip?.ADL === 0 ? 0 : ''),
                        //     CHD: priceInfo.price?.round_trip?.CHD ?? (priceInfo.price?.round_trip?.CHD === 0 ? 0 : ''),
                        //     INF: priceInfo.price?.round_trip?.INF ?? (priceInfo.price?.round_trip?.INF === 0 ? 0 : ''),
                        //     SNR: priceInfo.price?.round_trip?.SNR ?? (priceInfo.price?.round_trip?.SNR === 0 ? 0 : ''),
                        // },
                    })
                    }
                    return acc
                }, {})
            ),
        },
        validationSchema: Yup.object().shape({
            stops: Yup.array().of(
                Yup.object().shape({
                    tickets: Yup.array().of(
                        Yup.object().shape({
                            prices: Yup.object().shape({
                                ADL: Yup.number()
                                    .typeError('Adult price must be a number')
                                    .min(0, 'Adult price cannot be negative')
                                    .required('Adult price is required'),
                                CHD: Yup.number()
                                    .typeError('Child price must be a number')
                                    .min(0, 'Child price cannot be negative')
                                    .required('Child price is required'),
                                INF: Yup.number()
                                    .typeError('Infant price must be a number')
                                    .min(0, 'Infant price cannot be negative')
                                    .required('Infant price is required'),
                                SNR: Yup.number()
                                    .typeError('Senior Citizen price must be a number')
                                    .min(0, 'Senior Citizen price cannot be negative')
                                    .required('Senior Citizen price is required'),
                            }),
                            // round_trip_prices: Yup.object().shape({
                            //     ADL: Yup.number()
                            //         .typeError('Adult round trip price must be a number')
                            //         .min(0, 'Adult round trip price cannot be negative')
                            //         .nullable(),
                            //     CHD: Yup.number()
                            //         .typeError('Child round trip price must be a number')
                            //         .min(0, 'Child round trip price cannot be negative')
                            //         .nullable(),
                            //     INF: Yup.number()
                            //         .typeError('Infant round trip price must be a number')
                            //         .min(0, 'Infant round trip price cannot be negative')
                            //         .nullable(),
                            //     SNR: Yup.number()
                            //         .typeError('Senior Citizen round trip price must be a number')
                            //         .min(0, 'Senior Citizen round trip price cannot be negative')
                            //         .nullable(),
                            // }),
                        })
                    ),
                })
            ),
        }),
        onSubmit: values => {
            setSubmitLoading(true)
            handlePriceSubmit()
        },
    })

    const [updateRoutePrice, { loading: updatePriceLoading, error: updatePriceError }] = useMutation(
        UPDATE_BOAT_ROUTE_PRICE,
        {
            onCompleted: data => {
                if (data.updateBoatRoutePrice.success && data.updateBoatRoutePrice.code === '200') {
                    console.log('Price Updated Successfully')
                    setSubmitLoading(false)
                    setShowSucDialog(true)
                    setTimeout(() => {
                        setShowSucDialog(false)
                    }, 1500)
                } else {
                    setSubmitLoading(false)
                    setErrorMessage(data.updateBoatRoutePrice.message)
                    setShowErrDialog(true)
                }
            },
        }
    )

    const [updateCharterBoatRoutePrice, { loading: updateCharterPriceLoading }] = useMutation(
        UPDATE_CHARTER_BOAT_ROUTE_PRICE,
        {
            onCompleted: data => {
                if (data.updateCharterBoatRoutePrice.success && data.updateCharterBoatRoutePrice.code === '200') {
                    console.log('Charter Price Updated Successfully')
                    setSubmitLoading(false)
                    setShowSucDialog(true)
                    setTimeout(() => {
                        setShowSucDialog(false)
                    }, 1500)
                } else {
                    setSubmitLoading(false)
                    setErrorMessage(data.updateCharterBoatRoutePrice.message)
                    setShowErrDialog(true)
                }
            },
            onError: error => {
                setSubmitLoading(false)
                setErrorMessage(error.message)
                setShowErrDialog(true)
            },
        }
    )

    const handleCharterPriceSubmit = () => {
        setSubmitLoading(true)

        const charterPrices =
            priceFormValidation.values?.stops.flatMap(stop =>
                stop.tickets.map(ticket => ({
                    price_id: ticket.price_id,
                    route_id: id,
                    start_location_id: stop.start_location_id,
                    end_location_id: stop.end_location_id,
                    price: {
                        boat_price: stop.charter_price ? parseFloat(stop.charter_price) : 0,
                        // round_trip: {
                        //     boat_price: stop.charter_round_trip_price ? parseFloat(stop.charter_round_trip_price) : 0,
                        // },
                    },
                }))
            ) || []

        updateCharterBoatRoutePrice({
            variables: {
                routeId: id,
                prices: charterPrices,
            },
        })
    }

    const handlePriceSubmit = () => {
        const formattedPrice = priceFormValidation.values?.stops.flatMap(stop => {
            return stop.tickets.map(ticket => {
                const pricePayload = {
                    ADL: ticket.prices.ADL || 0,
                    CHD: ticket.prices.CHD || 0,
                    INF: ticket.prices.INF || 0,
                    SNR: ticket.prices.SNR || 0,
                }

                // Add round_trip if any value is provided
                // if (
                //     ticket.round_trip_prices &&
                //     (ticket.round_trip_prices.ADL ||
                //         ticket.round_trip_prices.CHD ||
                //         ticket.round_trip_prices.INF ||
                //         ticket.round_trip_prices.SNR)
                // ) {
                //     pricePayload.round_trip = {
                //         ADL: ticket.round_trip_prices.ADL || null,
                //         CHD: ticket.round_trip_prices.CHD || null,
                //         INF: ticket.round_trip_prices.INF || null,
                //         SNR: ticket.round_trip_prices.SNR || null,
                //     }
                // }

                return {
                    price_id: ticket.price_id,
                    seat_type_code: ticket.seat_type_code,
                    route_id: id,
                    start_location_id: stop.start_location_id,
                    end_location_id: stop.end_location_id,
                    price: pricePayload,
                }
            })
        })
        updateRoutePrice({
            variables: {
                routeId: id,
                prices: formattedPrice,
            },
        })
    }

    const serviceFormValidation = useFormik({
        enableReinitialize: true,
        initialValues: {
            cabin_upgrade_fee: '',
        },
        validationSchema: Yup.object({
            cabin_upgrade_fee: Yup.number()
                .typeError('It should be a number')
                .required('Cabin upgrade fee is required')
                .min(0, 'Fee must be 0 or greater'),
        }),
        onSubmit: (values, { resetForm }) => {
            setSubmitLoading(true)
            handleFeesSubmit(values)
            resetForm()
            setSubmitLoading(false)
        },
    })

    const [updateServiceFees, { loading: updateFeeLoading, error: updateFeeError }] = useMutation(
        UPDATE_BOAT_ROUTE_SERVICE_FEE,
        {
            onCompleted: data => {
                if (data.updateBoatRouteServiceFee.success && data.updateBoatRouteServiceFee.code === '200') {
                    console.log('Service Fees Updated Successfully')
                    setSubmitLoading(false)
                    setShowSucDialog(true)
                    setTimeout(() => {
                        setShowSucDialog(false)
                    }, 1500)
                } else {
                    setSubmitLoading(false)
                    setErrorMessage(data.updateBoatRoutePrice.message)
                    setShowErrDialog(true)
                }
            },
        }
    )

    const handleFeesSubmit = values => {
        const formattedService = {
            cabin_upgrade_fee: Number(values.cabin_upgrade_fee),
        }

        updateServiceFees({
            variables: {
                routeId: id,
                serviceFee: formattedService,
            },
            onCompleted: () =>
                getBoatRoutes({
                    variables: {
                        page: { limit: 10, offset: 0 },
                        statusCode: null,
                        routeName: null,
                        routeId: id,
                    },
                }),
        })
    }

    return (
        <>
            <div className="mb-6 flex justify-normal items-center">
                <button
                    onClick={handleBack}
                    type="button"
                    className="inline-flex items-center gap-x-0.5 rounded-md text-sm text-gray-600"
                >
                    <ArrowLeftIcon aria-hidden="true" className="-ml-0.5 h-5 w-4 rtl:rotate-180" />
                    {t('Back')}
                </button>
                <h3 className="text-lg font-bold leading-7 text-primary ps-2.5 pb-1">{t('Trips details')}</h3>
            </div>

            {routeListLoading && (
                <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
                    <img alt="logo" src={loadingImage} className="w-[250px]" />
                    <p className="pt-3 text-primary font-semibold">Loading, please wait...</p>
                </div>
            )}
            {routeListError && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('Failed to fetch routes!')}</div>
                </div>
            )}
            {!routeListLoading && !routeListError && routeList?.length === 0 && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('No route found!')}</div>
                </div>
            )}
            {!routeListLoading && !routeListError && routeList?.length > 0 && (
                <>
                    <TripAlert />
                    <div className="flex flex-wrap items-end justify-between gap-4">
                        <div className="max-sm:w-full sm:w-full">
                            <div className="md:flex md:items-center sm:justify-between md:space-x-5">
                                <div className="flex items-start space-x-5">
                                    <div className="flex-shrink-0">
                                        <div className="relative">
                                            <div className="w-16 h-16 bg-gray-50 p-4 flex justify-center items-center">
                                                <svg
                                                    height="100%"
                                                    viewBox="0 0 512 512"
                                                    width="100%"
                                                    className="fill-primary"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    id="fi_3710370"
                                                >
                                                    <g id="Navigator">
                                                        <path d="m456.59 74.3682a86.939 86.939 0 0 0 -132.2211 112.0053l56.8331 79.5625a17.1 17.1 0 0 0 27.832 0l56.833-79.5625a86.6665 86.6665 0 0 0 -9.277-112.0053zm-61.472 89.9763a28.5 28.5 0 1 1 28.5-28.5 28.5014 28.5014 0 0 1 -28.5 28.5z"></path>
                                                        <path d="m395.118 314.9019a17.0965 17.0965 0 0 0 -17.098 17.0981v36.46a60.4419 60.4419 0 1 1 -120.8838 0v-155.08a94.6382 94.6382 0 1 0 -189.2763 0v80.62a17.0982 17.0982 0 0 0 34.1963 0v-80.62a60.4419 60.4419 0 1 1 120.8837 0v155.08a94.6382 94.6382 0 0 0 189.2764 0v-36.46a17.0965 17.0965 0 0 0 -17.0983-17.0981z"></path>
                                                        <path d="m84.9578 352.9019a55.0981 55.0981 0 1 0 55.0982 55.0981 55.1578 55.1578 0 0 0 -55.0982-55.0981z"></path>
                                                    </g>
                                                </svg>
                                            </div>
                                            <span
                                                aria-hidden="true"
                                                className="absolute inset-0 rounded-lg shadow-inner"
                                            />
                                        </div>
                                    </div>
                                    <div className="pt-1.5">
                                        <h1 className="text-2xl font-bold text-gray-900">
                                            {routeList[0].route_name?.en}
                                        </h1>
                                        <p className="text-sm font-medium text-gray-500">
                                            {routeList[0].master_route?.waypoints?.length} {t('Waypoints')}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex space-y-4 space-y-reverse sm:flex-row-reverse justify-end sm:space-x-3 sm:space-y-0 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3">
                                    <button
                                        onClick={() =>
                                            navigate(`/metro-routes/metro-route-form/${routeList[0].route_id}`)
                                        }
                                        type="button"
                                        className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                    >
                                        {t('Edit Trip')}
                                    </button>
                                </div>
                            </div>

                            <div className="mt-6">
                                <div className="my-6">
                                    <dl className="divide-y divide-gray-100 border rounded-lg overflow-hidden border-gray-200">
                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Route Name (EN)')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {routeList[0].route_name?.en}
                                            </dd>
                                        </div>
                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Route Name (AR)')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {routeList[0].route_name?.ar}
                                            </dd>
                                        </div>
                                        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">Status</dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {routeList[0].status?.description?.en}
                                            </dd>
                                        </div>

                                        <div className="bg-white-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">{t('Boat')}</dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {routeList[0].boat?.name?.en}
                                            </dd>
                                        </div>

                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Charter Boat')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 sm:col-span-2 sm:mt-0">
                                                {routeList[0].is_charter ? (
                                                    <Badge color="lime">{t('Yes')}</Badge>
                                                ) : (
                                                    <Badge color="rose">{t('No')}</Badge>
                                                )}
                                            </dd>
                                        </div>

                                        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Days of Operation')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                <div className="flex flex-wrap gap-2">
                                                    {routeList[0].days_of_week.map(day => (
                                                        <span
                                                            key={day}
                                                            className="capitalize inline-flex items-center px-4 py-3 text-sm rounded-full bg-gray-50 text-black"
                                                        >
                                                            {day}
                                                        </span>
                                                    ))}
                                                </div>
                                            </dd>
                                        </div>

                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Waypoints')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                <div className="flex flex-wrap gap-2">
                                                    {routeList[0].master_route?.waypoints.map((waypoint, index) => {
                                                        return (
                                                            <>
                                                                <span
                                                                    key={waypoint.location_id}
                                                                    className="inline-flex items-center px-4 py-3 text-sm rounded-full bg-gray-50 text-black"
                                                                >
                                                                    {waypoint.location?.name?.en}
                                                                </span>
                                                                {index !==
                                                                    routeList[0].master_route?.waypoints.length - 1 && (
                                                                    <span
                                                                        key={waypoint.location.name.en}
                                                                        className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-full bg-white text-primary"
                                                                    >
                                                                        <ArrowRightIcon
                                                                            aria-hidden="true"
                                                                            className="-ml-0.5 h-5 w-5"
                                                                        />
                                                                    </span>
                                                                )}
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </dd>
                                        </div>

                                        {routeList[0].active_seat_layout && (
                                            <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                <dt className="text-sm font-medium leading-6 text-gray-900">
                                                    {t('Seat Layout')}
                                                </dt>
                                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                    <div className="space-y-1">
                                                        <p className="font-medium">
                                                            {routeList[0].active_seat_layout.description?.en ||
                                                                routeList[0].active_seat_layout.layout_key}
                                                        </p>
                                                        <p className="text-xs text-gray-500">
                                                            {t('Layout')}: {routeList[0].active_seat_layout.num_rows} x{' '}
                                                            {routeList[0].active_seat_layout.num_columns} (
                                                            {routeList[0].active_seat_layout.num_rows *
                                                                routeList[0].active_seat_layout.num_columns}{' '}
                                                            {t('seats')})
                                                        </p>
                                                    </div>
                                                </dd>
                                            </div>
                                        )}

                                        {routeList[0].trip_type && (
                                            <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                <dt className="text-sm font-medium leading-6 text-gray-900">
                                                    {t('Trip Type')}
                                                </dt>
                                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                    <span className="inline-flex items-center px-3 py-1 text-sm font-medium rounded-full bg-primary/10 text-primary">
                                                        {routeList[0].trip_type.description?.en ||
                                                            routeList[0].trip_type.code}
                                                    </span>
                                                </dd>
                                            </div>
                                        )}

                                        {/* Audit Information */}
                                        {routeList[0].user_audit && (
                                            <>
                                                <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                    <dt className="text-sm font-medium leading-6 text-gray-900">
                                                        {t('Created On')}
                                                    </dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {routeList[0].user_audit.created_date
                                                            ? customDateFormat(routeList[0].user_audit.created_date)
                                                            : 'N/A'}
                                                    </dd>
                                                </div>
                                                <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                    <dt className="text-sm font-medium leading-6 text-gray-900">
                                                        {t('Created By')}
                                                    </dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {routeList[0].user_audit.created_by || 'N/A'}
                                                    </dd>
                                                </div>
                                                {routeList[0].user_audit.modified_date && (
                                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Updated On')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {customDateFormat(routeList[0].user_audit.modified_date)}
                                                        </dd>
                                                    </div>
                                                )}
                                                {routeList[0].user_audit.modified_by && (
                                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Updated By')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {routeList[0].user_audit.modified_by}
                                                        </dd>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </dl>
                                </div>
                            </div>

                            <div className="bg-primary flex items-center justify-between border-x border-t rounded-t-lg overflow-hidden border-gray-100 px-3">
                                <nav aria-label="Tabs" className="space-x-4">
                                    {tabs.map(tab => (
                                        <button
                                            key={tab.name}
                                            onClick={() => setActiveTab(tab.key)}
                                            className={classNames(
                                                activeTab === tab.key
                                                    ? 'border-white text-white'
                                                    : 'border-transparent text-white/[.7] hover:border-gray-300 hover:text-white/[.9]',
                                                'whitespace-nowrap border-b-2 px-1 py-4 text-md font-medium'
                                            )}
                                        >
                                            {tab.name}
                                        </button>
                                    ))}
                                </nav>
                                {activeTab === 'trips' && (
                                    <button
                                        onClick={() =>
                                            navigate(`/metro-trips/metro-trip-form/${routeList[0].route_id}/0`)
                                        }
                                        type="button"
                                        className="h-[36] hover:bg-white/[.9] bg-white focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-primary shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                    >
                                        {t('Add Schedule')}
                                    </button>
                                )}
                                {activeTab === 'meals' && (
                                    <button
                                        onClick={() => setShowMealModal(true)}
                                        type="button"
                                        className="h-[36] hover:bg-white/[.9] bg-white focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-primary shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                    >
                                        {t('Add Meal')}
                                    </button>
                                )}
                                {activeTab === 'luggage' && (
                                    <button
                                        onClick={() => setShowLuggageModal(true)}
                                        type="button"
                                        className="h-[36] hover:bg-white/[.9] bg-white focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-primary shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                    >
                                        {t('Add Luggage')}
                                    </button>
                                )}
                                {activeTab === 'shuttle' && (
                                    <button
                                        onClick={() => setShowShuttleModal(true)}
                                        type="button"
                                        className="h-[36] hover:bg-white/[.9] bg-white focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-primary shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                    >
                                        {t('Add Shuttle Service')}
                                    </button>
                                )}
                            </div>
                            {/* Conditional rendering based on active tab */}

                            {activeTab === 'trips' && (
                                <div>
                                    <div className="bg-white flex flex-wrap items-end justify-between gap-4 border border-gray-100 rounded-t-lg overflow-hidden py-6 px-3">
                                        <div className="max-sm:w-full sm:flex-1">
                                            <div className="fle items-center gap-6 sm:flex-nowrap justify-between">
                                                <div className="flex flex-wrap items-center justify-between gap-6 sm:flex-nowrap">
                                                    {/* {!routeListLoading &&
                                                        !routeListError &&
                                                        routeList[0].route_trip?.length != 0 && (
                                                            <button
                                                                onClick={() => setIsTripFormOpen(true)}
                                                                className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                                            >
                                                                {t('Add Trip')}
                                                            </button>
                                                        )} */}
                                                </div>
                                            </div>

                                            {!routeListLoading &&
                                                !routeListError &&
                                                routeList[0].route_trip?.length == 0 && (
                                                    <div className="text-center py-24 bg-gray-50 border mt-8 rounded-lg">
                                                        <svg
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 24 24"
                                                            aria-hidden="true"
                                                            className="mx-auto h-12 w-12 text-gray-400"
                                                        >
                                                            <path
                                                                d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                                                                strokeWidth={2}
                                                                vectorEffect="non-scaling-stroke"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                        <h3 className="mt-2 text-sm font-semibold text-gray-900">
                                                            {t('No Schedule found!')}
                                                        </h3>
                                                        <p className="mt-1 text-sm text-gray-500">
                                                            {t('Please add Schedule and try again.')}
                                                        </p>
                                                        <div className="mt-6">
                                                            <a
                                                                href={`/metro-trips/metro-trip-form/${routeList[0].route_id}/0`}
                                                                className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                                            >
                                                                {t('Add Schedule')}
                                                            </a>
                                                        </div>
                                                    </div>
                                                )}
                                            {!routeListLoading &&
                                                !routeListError &&
                                                routeList[0].route_trip?.length > 0 && (
                                                    <>
                                                        <div className="my-4 flex flex-col sm:flex-row  max-w-xl gap-4">
                                                            <div>
                                                                <BoatRouteTripStatusDropdown
                                                                    fields={{
                                                                        name: 'trip_status',
                                                                        value: searchTripStatus,
                                                                        onChange: handleRouteTripStatusChange,
                                                                    }}
                                                                    error=""
                                                                    helperText=""
                                                                    purpose="filter"
                                                                />
                                                            </div>
                                                            <div className="flex-1">
                                                                <InputGroup>
                                                                    <MagnifyingGlassIcon />
                                                                    <Input
                                                                        id="search"
                                                                        value={searchString}
                                                                        onChange={e => setSearchString(e.target.value)}
                                                                        placeholder="Search trips"
                                                                    />
                                                                </InputGroup>
                                                            </div>
                                                            <div className="flex gap-2 justify-end">
                                                                <button
                                                                    type="button"
                                                                    onClick={e => {
                                                                        e.stopPropagation()
                                                                        onClickSearch()
                                                                    }}
                                                                    className="inline-flex items-center justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/[0.9]"
                                                                >
                                                                    {t('Search')}
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={e => {
                                                                        e.stopPropagation()
                                                                        onClickSearchClear()
                                                                    }}
                                                                    className="inline-flex items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                                >
                                                                    {t('Clear')}
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <Divider />
                                                        {filterTripList && filterTripList.length == -0 && (
                                                            <GraphQlResponseNoData />
                                                        )}

                                                        {filterTripList && filterTripList.length > 0 && (
                                                            <div className="table-custom overflow-x-scroll lg:overflow-hidden rounded-b-lg flex">
                                                                <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableHeader>#</TableHeader>
                                                                            <TableHeader>{t('Trip Name')}</TableHeader>
                                                                            <TableHeader>{t('Start Time')}</TableHeader>
                                                                            <TableHeader>{t('End Time')}</TableHeader>
                                                                            <TableHeader>{t('Waypoints')}</TableHeader>
                                                                            <TableHeader>
                                                                                {t('Valid From To')}
                                                                            </TableHeader>
                                                                            <TableHeader>{t('Status')}</TableHeader>
                                                                            <TableHeader className="text-right">
                                                                                {t('Actions')}
                                                                            </TableHeader>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {filterTripList.map((trip, index) => (
                                                                            <TableRow
                                                                                className="cursor-pointer hover:bg-gray-50"
                                                                                key={index}
                                                                                href={`metro-trips/metro-trip-details/${trip.trip_id}`}
                                                                            >
                                                                                <TableCell>{index + 1}</TableCell>
                                                                                <TableCell>
                                                                                    {trip.trip_name?.en}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {customTimeFormat(trip.start_time)}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {customTimeFormat(trip.end_time)}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {
                                                                                        routeList[0].master_route
                                                                                            ?.waypoints?.length
                                                                                    }
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {customDateFormat(trip.valid_from)}{' '}
                                                                                    - {customDateFormat(trip.valid_to)}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <Badge color="lime">
                                                                                        {trip.status?.description?.en}
                                                                                    </Badge>
                                                                                </TableCell>
                                                                                <TableCell className="text-right">
                                                                                    {' '}
                                                                                    <Dropdown>
                                                                                        <DropdownButton
                                                                                            plain
                                                                                            aria-label="More options"
                                                                                        >
                                                                                            <EllipsisVerticalIcon />
                                                                                        </DropdownButton>
                                                                                        <DropdownMenu anchor="bottom">
                                                                                            <DropdownItem
                                                                                                href={`metro-trips/metro-trip-details/${trip.trip_id}`}
                                                                                            >
                                                                                                <EyeIcon />
                                                                                                <DropdownLabel>
                                                                                                    {t('View')}
                                                                                                </DropdownLabel>
                                                                                            </DropdownItem>
                                                                                            <DropdownDivider />
                                                                                            <DropdownItem
                                                                                                href={`/metro-trips/metro-trip-form/${routeList[0].route_id}/${trip.trip_id}`}
                                                                                            >
                                                                                                <PencilIcon />
                                                                                                <DropdownLabel>
                                                                                                    {t('Edit')}
                                                                                                </DropdownLabel>
                                                                                            </DropdownItem>
                                                                                            <DropdownItem
                                                                                                href={`/metro-routes/captain-details/${routeList[0].route_id}/${trip.trip_id}`}
                                                                                            >
                                                                                                <CaptainIcon className="w-[15px] h-[15px] fill-[#285f74] group-hover:fill-white" />
                                                                                                <DropdownLabel>
                                                                                                    {t('Captains')}
                                                                                                </DropdownLabel>
                                                                                            </DropdownItem>
                                                                                        </DropdownMenu>
                                                                                    </Dropdown>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'pricing' && (
                                <div>
                                    {routePriceList.length === 0 && (
                                        <>
                                            <div className="text-center py-24 bg-gray-50 border mt-8 rounded-lg">
                                                <svg
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                    aria-hidden="true"
                                                    className="mx-auto h-12 w-12 text-gray-400"
                                                >
                                                    <path
                                                        d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                                                        strokeWidth={2}
                                                        vectorEffect="non-scaling-stroke"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                                <h3 className="mt-2 text-sm font-semibold text-gray-900">
                                                    {t('No Price details found!')}
                                                </h3>
                                                <p className="mt-1 text-sm text-gray-500">{t('Please try again.')}</p>
                                            </div>
                                        </>
                                    )}

                                    {/* Charter Boat Price Block */}
                                    {routeList[0]?.is_charter && (
                                        <form className=" border border-gray-100 py-6 px-3">
                                            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                                                {/* Left header */}
                                                <div>
                                                    <h2 className="text-base font-semibold leading-7 text-gray-900">
                                                        {t('Charter Pricing')}
                                                    </h2>
                                                    <p className="mt-1 text-sm leading-6 text-gray-600">
                                                        {t('Set the price for the charter boat.')}
                                                    </p>
                                                </div>

                                                {/* Right inputs */}
                                                <div className="grid max-w-2xl grid-cols-1 gap-x-3 sm:grid-cols-6 md:col-span-2">
                                                    {priceFormValidation.values.stops.map((stop, stopIndex) => (
                                                        <div
                                                            key={`${stop.start_location_id}_${stop.end_location_id}`}
                                                            className="sm:col-span-full mt-6 border-b border-gray-200 pb-6"
                                                        >
                                                            {/* Stations header */}
                                                            <div className="sm:col-span-full flex gap-1 items-center justify-between border p-3 bg-primary/[0.1] rounded-md">
                                                                <div className="text-start">
                                                                    <p className="text-xs text-gray-500">
                                                                        {t('From Point')}
                                                                    </p>
                                                                    <h2 className="text-base font-semibold text-gray-900">
                                                                        {stop.start_location_name}
                                                                    </h2>
                                                                </div>
                                                                <div className="w-10 h-10 bg-gray-50 rounded-full text-primary flex justify-center items-center">
                                                                    <ArrowRightIcon
                                                                        className="h-5 w-5"
                                                                        aria-hidden="true"
                                                                    />
                                                                </div>
                                                                <div className="text-end">
                                                                    <p className="text-xs text-gray-500">
                                                                        {t('To Point')}
                                                                    </p>
                                                                    <h2 className="text-base font-semibold text-gray-900">
                                                                        {stop.end_location_name}
                                                                    </h2>
                                                                </div>
                                                            </div>

                                                            {/* Whole boat price */}
                                                            <div className="mt-4 px-3">
                                                                <label className="block text-sm font-medium text-gray-900">
                                                                    {t('Charter Boat Price')}
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    name={`stops.${stopIndex}.charter_price`}
                                                                    value={stop.charter_price || ''}
                                                                    onChange={priceFormValidation.handleChange}
                                                                    onBlur={priceFormValidation.handleBlur}
                                                                    placeholder="Enter here..."
                                                                    className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 text-gray-900 shadow-sm focus:border-primary focus:ring-primary sm:text-sm"
                                                                />
                                                            </div>
                                                            {/* Round-trip price - commented out
                                                            <div className="mt-4 px-3">
                                                                <div className="sm:col-span-full pt-4 border-t border-gray-200">
                                                                    <p className="text-sm font-semibold text-primary mb-2">
                                                                        {t('Round Trip Price')}
                                                                    </p>
                                                                    <p className="text-xs text-gray-500 mb-3">
                                                                        {t(
                                                                            'Optional: Set special pricing for round trip bookings'
                                                                        )}
                                                                    </p>
                                                                </div>
                                                                <input
                                                                    type="number"
                                                                    name={`stops.${stopIndex}.charter_round_trip_price`}
                                                                    value={stop.charter_round_trip_price || ''}
                                                                    onChange={priceFormValidation.handleChange}
                                                                    onBlur={priceFormValidation.handleBlur}
                                                                    placeholder="Optional"
                                                                    className="mt-1 block w-full rounded-md border border-gray-300 py-2 px-3 text-gray-900 shadow-sm focus:border-primary focus:ring-primary sm:text-sm"
                                                                />
                                                            </div>
                                                            */}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Save button */}
                                            <div className="flex justify-end mt-4">
                                                <button
                                                    type="button"
                                                    onClick={handleCharterPriceSubmit}
                                                    className="bg-primary text-white px-4 py-2 rounded-md text-sm font-semibold hover:bg-primary/[0.9]"
                                                >
                                                    {t('Save')}
                                                </button>
                                            </div>
                                        </form>
                                    )}

                                    {routePriceList.length > 0 && !routeList[0]?.is_charter && (
                                        <form className=" border border-gray-100 py-6 px-3">
                                            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                                                <div>
                                                    <h2 className="text-base font-semibold leading-7 text-gray-900">
                                                        {t('Ticket Pricing')}
                                                    </h2>
                                                    <p className="mt-1 text-sm leading-6 text-gray-600">
                                                        {t(
                                                            'Provide the details of ticket price for both VIP & standard Seats'
                                                        )}
                                                    </p>
                                                </div>
                                                <div className="grid max-w-2xl grid-cols-1 gap-x-3  sm:grid-cols-6 md:col-span-2">
                                                    {Array.isArray(priceFormValidation.values.stops) &&
                                                        priceFormValidation.values.stops.map((stop, index) => (
                                                            <div
                                                                key={`${stop.start_location_id}_${stop.end_location_id}`}
                                                                className="sm:col-span-full mt-6 border-b border-gray-200"
                                                            >
                                                                {/* Header showing start and end locations */}
                                                                <div className="sm:col-span-full flex gap-1 items-center justify-between border p-3 bg-primary/[0.1]">
                                                                    <div className="text-start">
                                                                        <p className="text-xs">{t('From Point')}</p>
                                                                        <h2 className="sm:col-span-full text-base font-semibold text-gray-900">
                                                                            {stop.start_location_name}
                                                                        </h2>
                                                                    </div>
                                                                    <div className="w-10 h-10 bg-gray-50 rounded-full text-primary flex justify-center items-center">
                                                                        <ArrowRightIcon
                                                                            aria-hidden="true"
                                                                            className="h-5 w-5"
                                                                        />
                                                                    </div>
                                                                    <div className="text-end">
                                                                        <p className="text-xs">{t('To Point')}</p>
                                                                        <h2 className="sm:col-span-full text-base font-semibold text-gray-900">
                                                                            {stop.end_location_name}
                                                                        </h2>
                                                                    </div>
                                                                </div>

                                                                {/* Iterate through seat types within each stop */}
                                                                {stop.tickets.map((seatType, seatIndex) => {
                                                                    if (seatType.seat_type_name === 'Standard and VIP') return null
                                                                    return (
                                                                    <div
                                                                        key={seatIndex}
                                                                        className="sm:col-span-full mt-3 border-b border-gray-200"
                                                                    >
                                                                        {/* Display seat type (e.g., VIP, STD) */}
                                                                        <div className="sm:col-span-full flex gap-1 items-center border-b p-3">
                                                                            <TicketIcon
                                                                                aria-hidden="true"
                                                                                className={`h-5 w-5 ${
                                                                                    seatType.seat_type_name === 'VIP'
                                                                                        ? 'text-gold'
                                                                                        : 'text-blue'
                                                                                }`}
                                                                            />
                                                                            <div className="text-end flex justify-between w-full">
                                                                                <p className="sm:col-span-full text-sm font-medium text-gray-900">
                                                                                    {seatType.seat_type_name}
                                                                                </p>
                                                                                <p className="sm:col-span-full text-sm font-medium text-gray-400">
                                                                                    {t('Price in BHD')}
                                                                                </p>
                                                                            </div>
                                                                        </div>

                                                                        {/* Display input fields for each price category (ADL, CHD, INF, SNR) */}
                                                                        <div className="sm:col-span-full grid grid-cols-1 sm:grid-cols-12 gap-3 sm:col-span-full px-3 py-6 bg-gray-50">
                                                                            {/* Adult Price */}
                                                                            <div className="sm:col-span-3">
                                                                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                                                                    {t('Adult')}
                                                                                    <span className="text-red">*</span>
                                                                                </label>
                                                                                <input
                                                                                    id={`stops.${index}.tickets.${seatIndex}.prices.ADL`}
                                                                                    name={`stops.${index}.tickets.${seatIndex}.prices.ADL`}
                                                                                    type="number"
                                                                                    onChange={
                                                                                        priceFormValidation.handleChange
                                                                                    }
                                                                                    onBlur={
                                                                                        priceFormValidation.handleBlur
                                                                                    }
                                                                                    value={seatType.prices.ADL}
                                                                                    placeholder="Enter here.."
                                                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                                                                />
                                                                                {priceFormValidation.touched.stops?.[
                                                                                    index
                                                                                ]?.tickets?.[seatIndex]?.prices?.ADL &&
                                                                                priceFormValidation.errors.stops?.[
                                                                                    index
                                                                                ]?.tickets?.[seatIndex]?.prices?.ADL ? (
                                                                                    <p className="text-error text-xs mt-1">
                                                                                        {
                                                                                            priceFormValidation.errors
                                                                                                .stops[index].tickets[
                                                                                                seatIndex
                                                                                            ].prices.ADL
                                                                                        }
                                                                                    </p>
                                                                                ) : null}
                                                                            </div>

                                                                            {/* Child Price */}
                                                                            <div className="sm:col-span-3">
                                                                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                                                                    {t('Child')}
                                                                                    <span className="text-red">*</span>
                                                                                </label>
                                                                                <input
                                                                                    id={`stops.${index}.tickets.${seatIndex}.prices.CHD`}
                                                                                    name={`stops.${index}.tickets.${seatIndex}.prices.CHD`}
                                                                                    type="number"
                                                                                    onChange={
                                                                                        priceFormValidation.handleChange
                                                                                    }
                                                                                    onBlur={
                                                                                        priceFormValidation.handleBlur
                                                                                    }
                                                                                    value={seatType.prices.CHD}
                                                                                    placeholder="Enter here.."
                                                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                                                                />
                                                                                {priceFormValidation.touched.stops?.[
                                                                                    index
                                                                                ]?.tickets?.[seatIndex]?.prices?.CHD &&
                                                                                priceFormValidation.errors.stops?.[
                                                                                    index
                                                                                ]?.tickets?.[seatIndex]?.prices?.CHD ? (
                                                                                    <p className="text-error text-xs mt-1">
                                                                                        {
                                                                                            priceFormValidation.errors
                                                                                                .stops[index].tickets[
                                                                                                seatIndex
                                                                                            ].prices.CHD
                                                                                        }
                                                                                    </p>
                                                                                ) : null}
                                                                            </div>

                                                                            {/* Infant Price */}
                                                                            <div className="sm:col-span-3">
                                                                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                                                                    {t('Infant')}
                                                                                    <span className="text-red">*</span>
                                                                                </label>
                                                                                <input
                                                                                    id={`stops.${index}.tickets.${seatIndex}.prices.INF`}
                                                                                    name={`stops.${index}.tickets.${seatIndex}.prices.INF`}
                                                                                    type="number"
                                                                                    onChange={
                                                                                        priceFormValidation.handleChange
                                                                                    }
                                                                                    onBlur={
                                                                                        priceFormValidation.handleBlur
                                                                                    }
                                                                                    value={seatType.prices.INF}
                                                                                    placeholder="Enter here.."
                                                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                                                                />
                                                                                {priceFormValidation.touched.stops?.[
                                                                                    index
                                                                                ]?.tickets?.[seatIndex]?.prices?.INF &&
                                                                                priceFormValidation.errors.stops?.[
                                                                                    index
                                                                                ]?.tickets?.[seatIndex]?.prices?.INF ? (
                                                                                    <p className="text-error text-xs mt-1">
                                                                                        {
                                                                                            priceFormValidation.errors
                                                                                                .stops[index].tickets[
                                                                                                seatIndex
                                                                                            ].prices.INF
                                                                                        }
                                                                                    </p>
                                                                                ) : null}
                                                                            </div>

                                                                            {/* Senior Citizen Price */}
                                                                            <div className="sm:col-span-3">
                                                                                <label className="block text-sm font-medium leading-6 text-gray-900">
                                                                                    {t('Senior Citizen')}
                                                                                    <span className="text-red">*</span>
                                                                                </label>
                                                                                <input
                                                                                    id={`stops.${index}.tickets.${seatIndex}.prices.SNR`}
                                                                                    name={`stops.${index}.tickets.${seatIndex}.prices.SNR`}
                                                                                    type="number"
                                                                                    onChange={
                                                                                        priceFormValidation.handleChange
                                                                                    }
                                                                                    onBlur={
                                                                                        priceFormValidation.handleBlur
                                                                                    }
                                                                                    value={seatType.prices.SNR}
                                                                                    placeholder="Enter here.."
                                                                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                                                                />
                                                                                {priceFormValidation.touched.stops?.[
                                                                                    index
                                                                                ]?.tickets?.[seatIndex]?.prices?.SNR &&
                                                                                priceFormValidation.errors.stops?.[
                                                                                    index
                                                                                ]?.tickets?.[seatIndex]?.prices?.SNR ? (
                                                                                    <p className="text-error text-xs mt-1">
                                                                                        {
                                                                                            priceFormValidation.errors
                                                                                                .stops[index].tickets[
                                                                                                seatIndex
                                                                                            ].prices.SNR
                                                                                        }
                                                                                    </p>
                                                                                ) : null}
                                                                            </div>
                                                                        </div>

                                                                        {/* Round Trip Pricing Section removed */}
                                                                    </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        ))}
                                                </div>
                                                <div className="flex justify-end items-center md:col-span-full">
                                                    <div className="flex gap-3">
                                                        <button
                                                            disabled={updatePriceLoading}
                                                            type="button"
                                                            onClick={() => {
                                                                priceFormValidation.handleSubmit()
                                                            }}
                                                            className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                                        >
                                                            {t('Save')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            )}

                            {activeTab === 'service fees' && (
                                <div>
                                    {!serviceFeesList || serviceFeesList.length === 0 ? (
                                        <div className="text-center py-24 bg-gray-50 border mt-8 rounded-lg">
                                            <svg
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                                className="mx-auto h-12 w-12 text-gray-400"
                                            >
                                                <path
                                                    d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                                                    strokeWidth={2}
                                                    vectorEffect="non-scaling-stroke"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                            <h3 className="mt-2 text-sm font-semibold text-gray-900">
                                                {t('No fees details found!')}
                                            </h3>
                                            <p className="mt-1 text-sm text-gray-500">{t('Please try again.')}</p>
                                        </div>
                                    ) : (
                                        <form className="border border-gray-100 py-6 px-3">
                                            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                                                <div>
                                                    <h2 className="text-base font-semibold leading-7 text-gray-900">
                                                        {t('Cabin Upgrade Fee')}
                                                    </h2>
                                                    <p className="mt-1 text-sm leading-6 text-gray-600">
                                                        {t('Provide the upgrade cabin fee for service config')}
                                                    </p>
                                                </div>
                                                <div className="grid max-w-2xl grid-cols-1 sm:grid-cols-6 md:col-span-2 gap-4">
                                                    <div className="sm:col-span-full mt-6 border-b border-gray-200">
                                                        <div className="sm:col-span-full grid grid-cols-1 sm:grid-cols-12 items-center gap-3 p-3 bg-primary/[0.1]">
                                                            <p className="col-span-4 text-xs">
                                                                {t('Cabin Upgrade Fee')}
                                                            </p>
                                                            <h2 className="col-span-8 text-base font-semibold text-gray-900">
                                                                {serviceFeesList.find(fee => fee.route_id === id)
                                                                    ?.service_fee_config?.cabin_upgrade_fee ?? ''}
                                                            </h2>
                                                        </div>
                                                    </div>

                                                    <div className="sm:col-span-full mt-3 border-b border-gray-200">
                                                        <div className="sm:col-span-full grid grid-cols-1 sm:grid-cols-12 items-center gap-3 px-3 py-6 bg-gray-50">
                                                            <label className="col-span-4 block text-sm font-medium leading-6 text-gray-900">
                                                                {t('Cabin Upgrade Fee')}
                                                            </label>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                step="any"
                                                                placeholder="Enter fee"
                                                                className="col-span-8 block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                                                                {...serviceFormValidation.getFieldProps(
                                                                    'cabin_upgrade_fee'
                                                                )}
                                                            />
                                                        </div>
                                                        {/* Validation Error */}
                                                        {serviceFormValidation.touched.cabin_upgrade_fee &&
                                                            serviceFormValidation.errors.cabin_upgrade_fee && (
                                                                <p className="col-span-12 text-error text-xs mt-1">
                                                                    {serviceFormValidation.errors.cabin_upgrade_fee}
                                                                </p>
                                                            )}
                                                    </div>
                                                </div>

                                                {/* Submit button */}
                                                <div className="flex justify-end items-center md:col-span-3">
                                                    <button
                                                        disabled={updateFeeLoading}
                                                        type="button"
                                                        onClick={serviceFormValidation.handleSubmit}
                                                        className="hover:bg-primary/[.9] bg-primary rounded-md px-3 py-1.5 text-sm font-semibold text-white"
                                                    >
                                                        {t('Save')}
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            )}

                            {activeTab === 'meals' && (
                                <div>
                                    <div className="bg-white flex flex-wrap items-end justify-between gap-4 border border-gray-100 py-6 px-3">
                                        <div className="max-sm:w-full sm:flex-1">
                                            {tripMealsLoading && (
                                                <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
                                                    <img alt="logo" src={loadingImage} className="w-[250px]" />
                                                    <p className="pt-3 text-primary font-semibold">
                                                        Loading, please wait...
                                                    </p>
                                                </div>
                                            )}

                                            {tripMealsError && (
                                                <div className="flex justify-center items-center bg-white py-5">
                                                    <div className="text-lg text-center">
                                                        {t('Failed to fetch meals!')}
                                                    </div>
                                                </div>
                                            )}

                                            {!tripMealsLoading && !tripMealsError && mealList?.length === 0 && (
                                                <div className="text-center py-24 bg-gray-50 border mt-8 rounded-lg">
                                                    <svg
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                        aria-hidden="true"
                                                        className="mx-auto h-12 w-12 text-gray-400"
                                                    >
                                                        <path
                                                            d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                                                            strokeWidth={2}
                                                            vectorEffect="non-scaling-stroke"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                    <h3 className="mt-2 text-sm font-semibold text-gray-900">
                                                        {t('No meals found!')}
                                                    </h3>
                                                    <p className="mt-1 text-sm text-gray-500">
                                                        {t('Please add meals to this trip.')}
                                                    </p>
                                                    <div className="mt-6">
                                                        <button
                                                            onClick={() => setShowMealModal(true)}
                                                            type="button"
                                                            className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                                        >
                                                            {t('Add Meal')}
                                                        </button>
                                                    </div>
                                                </div>
                                            )}

                                            {!tripMealsLoading && !tripMealsError && mealList?.length > 0 && (
                                                <div className="table-custom overflow-x-scroll lg:overflow-hidden rounded-b-lg flex">
                                                    <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableHeader>#</TableHeader>
                                                                <TableHeader>{t('English Description')}</TableHeader>
                                                                <TableHeader>{t('Arabic Description')}</TableHeader>
                                                                <TableHeader>{t('Price (Base)')}</TableHeader>
                                                                <TableHeader>{t('Tax')}</TableHeader>
                                                                <TableHeader>{t('Total Price')}</TableHeader>
                                                                <TableHeader>{t('Status')}</TableHeader>
                                                                <TableHeader className="text-right">
                                                                    {t('Actions')}
                                                                </TableHeader>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {mealList.map((tripMeal, index) => (
                                                                <TableRow
                                                                    className="cursor-pointer hover:bg-gray-50"
                                                                    key={tripMeal.trip_meal_id}
                                                                >
                                                                    <TableCell>{index + 1}</TableCell>
                                                                    <TableCell>
                                                                        {tripMeal.meal_detail.description.en}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {tripMeal.meal_detail.description.ar}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {tripMeal.meal_detail.price.base}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {tripMeal.meal_detail.price.tax}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        {(
                                                                            parseFloat(
                                                                                tripMeal.meal_detail.price.base
                                                                            ) +
                                                                            parseFloat(tripMeal.meal_detail.price.tax)
                                                                        ).toFixed(2)}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <div className="flex items-center gap-2">
                                                                            <Badge
                                                                                color={
                                                                                    tripMeal.meal_detail.active
                                                                                        ? 'lime'
                                                                                        : 'red'
                                                                                }
                                                                            >
                                                                                {tripMeal.meal_detail.active
                                                                                    ? t('Active')
                                                                                    : t('Inactive')}
                                                                            </Badge>
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell className="text-right">
                                                                        <Dropdown>
                                                                            <DropdownButton
                                                                                plain
                                                                                aria-label="More options"
                                                                            >
                                                                                <EllipsisVerticalIcon />
                                                                            </DropdownButton>
                                                                            <DropdownMenu anchor="bottom">
                                                                                <DropdownItem>
                                                                                    <EyeIcon />
                                                                                    <DropdownLabel>
                                                                                        {t('View')}
                                                                                    </DropdownLabel>
                                                                                </DropdownItem>
                                                                                <DropdownDivider />
                                                                                <DropdownItem
                                                                                    onClick={() =>
                                                                                        handleRemoveMeal(
                                                                                            tripMeal.trip_meal_id
                                                                                        )
                                                                                    }
                                                                                    disabled={removeMealLoading}
                                                                                >
                                                                                    <TrashIcon />
                                                                                    <DropdownLabel>
                                                                                        {t('Remove')}
                                                                                    </DropdownLabel>
                                                                                </DropdownItem>
                                                                            </DropdownMenu>
                                                                        </Dropdown>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'luggage' && (
                                <div>
                                    <div className="bg-white flex flex-wrap items-end justify-between gap-4 border border-gray-100 py-6 px-3">
                                        <div className="max-sm:w-full sm:flex-1">
                                            <div className="space-y-6">
                                                <div>
                                                    {tripLuggagesLoading && (
                                                        <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
                                                            <img alt="logo" src={loadingImage} className="w-[250px]" />
                                                            <p className="pt-3 text-primary font-semibold">
                                                                Loading, please wait...
                                                            </p>
                                                        </div>
                                                    )}

                                                    {tripLuggagesError && (
                                                        <div className="flex justify-center items-center bg-white py-5">
                                                            <div className="text-lg text-center">
                                                                {t('Failed to fetch luggages!')}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {!tripLuggagesLoading &&
                                                        !tripLuggagesError &&
                                                        luggageList?.length === 0 && (
                                                            <div className="text-center py-24 bg-gray-50 border mt-8 rounded-lg">
                                                                <svg
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    viewBox="0 0 24 24"
                                                                    aria-hidden="true"
                                                                    className="mx-auto h-12 w-12 text-gray-400"
                                                                >
                                                                    <path
                                                                        d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                                                                        strokeWidth={2}
                                                                        vectorEffect="non-scaling-stroke"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                                <h3 className="mt-2 text-sm font-semibold text-gray-900">
                                                                    {t('No luggages found!')}
                                                                </h3>
                                                                <p className="mt-1 text-sm text-gray-500">
                                                                    {t('Please add luggages to this trip.')}
                                                                </p>
                                                                <div className="mt-6">
                                                                    <button
                                                                        onClick={() => setShowLuggageModal(true)}
                                                                        type="button"
                                                                        className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                                                    >
                                                                        {t('Add Luggage')}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    {!tripLuggagesLoading &&
                                                        !tripLuggagesError &&
                                                        luggageList?.length > 0 && (
                                                            <div className="table-custom overflow-x-scroll lg:overflow-hidden rounded-b-lg flex">
                                                                <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableHeader>#</TableHeader>
                                                                            <TableHeader>
                                                                                {t('Luggage Type')}
                                                                            </TableHeader>
                                                                            <TableHeader>{t('Seat Type')}</TableHeader>
                                                                            <TableHeader>{t('Weight')}</TableHeader>
                                                                            <TableHeader>{t('Category')}</TableHeader>
                                                                            <TableHeader>{t('Price')}</TableHeader>
                                                                            <TableHeader>{t('Status')}</TableHeader>
                                                                            <TableHeader className="text-right">
                                                                                {t('Actions')}
                                                                            </TableHeader>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {luggageList.map((tripLuggage, index) => (
                                                                            <TableRow
                                                                                className="cursor-pointer hover:bg-gray-50"
                                                                                key={tripLuggage.trip_luggage_id}
                                                                            >
                                                                                <TableCell>{index + 1}</TableCell>
                                                                                <TableCell>
                                                                                    {
                                                                                        tripLuggage.luggage_detail
                                                                                            .metadata.luggage_type
                                                                                    }
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {tripLuggage.luggage_detail.metadata
                                                                                        .seat_type === 'VIP'
                                                                                        ? 'VIP'
                                                                                        : 'Standard'}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {tripLuggage.luggage_detail.weight}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {
                                                                                        tripLuggage.luggage_detail
                                                                                            .metadata.category
                                                                                    }
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {parseFloat(
                                                                                        tripLuggage.luggage_detail.price
                                                                                            .base
                                                                                    ).toFixed(2)}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <div className="flex items-center gap-2">
                                                                                        <Badge
                                                                                            color={
                                                                                                tripLuggage.status ===
                                                                                                'ACT'
                                                                                                    ? 'lime'
                                                                                                    : 'red'
                                                                                            }
                                                                                        >
                                                                                            {tripLuggage.status ===
                                                                                            'ACT'
                                                                                                ? t('Active')
                                                                                                : t('Inactive')}
                                                                                        </Badge>
                                                                                    </div>
                                                                                </TableCell>
                                                                                <TableCell className="text-right">
                                                                                    <Dropdown>
                                                                                        <DropdownButton
                                                                                            plain
                                                                                            aria-label="More options"
                                                                                        >
                                                                                            <EllipsisVerticalIcon />
                                                                                        </DropdownButton>
                                                                                        <DropdownMenu anchor="bottom">
                                                                                            <DropdownItem
                                                                                                onClick={() => {
                                                                                                    if (
                                                                                                        tripLuggage.status ===
                                                                                                        'ACT'
                                                                                                    ) {
                                                                                                        handleDisableLuggage(
                                                                                                            tripLuggage.trip_luggage_id
                                                                                                        )
                                                                                                    } else {
                                                                                                        handleEnableLuggage(
                                                                                                            tripLuggage.trip_luggage_id
                                                                                                        )
                                                                                                    }
                                                                                                }}
                                                                                                disabled={
                                                                                                    enableDisableLuggageLoading
                                                                                                }
                                                                                            >
                                                                                                {tripLuggage.status ===
                                                                                                'ACT' ? (
                                                                                                    <XMarkIcon />
                                                                                                ) : (
                                                                                                    <CheckIcon />
                                                                                                )}
                                                                                                <DropdownLabel>
                                                                                                    {t(
                                                                                                        tripLuggage.status ===
                                                                                                            'ACT'
                                                                                                            ? 'Deactivate'
                                                                                                            : 'Activate'
                                                                                                    )}
                                                                                                </DropdownLabel>
                                                                                            </DropdownItem>
                                                                                        </DropdownMenu>
                                                                                    </Dropdown>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {activeTab === 'shuttle' && (
                                <div>
                                    <div className="bg-white flex flex-wrap items-end justify-between gap-4 border border-gray-100 py-6 px-3">
                                        <div className="w-full">
                                            {routeShuttleServicesLoading && (
                                                <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
                                                    <img alt="logo" src={loadingImage} className="w-[250px]" />
                                                    <p className="pt-3 text-primary font-semibold">
                                                        Loading, please wait...
                                                    </p>
                                                </div>
                                            )}

                                            {routeShuttleServicesError && (
                                                <div className="flex justify-center items-center bg-white py-5">
                                                    <div className="text-lg text-center">
                                                        {t('Failed to fetch shuttle services!')}
                                                    </div>
                                                </div>
                                            )}

                                            {!routeShuttleServicesLoading &&
                                                !routeShuttleServicesError &&
                                                (!shuttleServiceList || shuttleServiceList.length === 0) && (
                                                    <div className="text-center py-24 bg-gray-50 border mt-8 rounded-lg">
                                                        <svg
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 24 24"
                                                            aria-hidden="true"
                                                            className="mx-auto h-12 w-12 text-gray-400"
                                                        >
                                                            <path
                                                                d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                                                                strokeWidth={2}
                                                                vectorEffect="non-scaling-stroke"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                        <h3 className="mt-2 text-sm font-semibold text-gray-900">
                                                            {t('No shuttle services found!')}
                                                        </h3>
                                                        <p className="mt-1 text-sm text-gray-500">
                                                            {t('Please add shuttle services to this route.')}
                                                        </p>
                                                        <div className="mt-6">
                                                            <button
                                                                onClick={() => setShowShuttleModal(true)}
                                                                className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                                            >
                                                                {t('Add Shuttle Service')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}

                                            {!routeShuttleServicesLoading &&
                                                !routeShuttleServicesError &&
                                                shuttleServiceList &&
                                                shuttleServiceList.length > 0 && (
                                                    <div className="table-custom overflow-x-scroll lg:overflow-hidden rounded-b-lg flex">
                                                        <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableHeader>#</TableHeader>
                                                                    <TableHeader>{t('Provider Name')}</TableHeader>
                                                                    <TableHeader>
                                                                        {t('Service Description (EN)')}
                                                                    </TableHeader>
                                                                    <TableHeader>
                                                                        {t('Service Description (AR)')}
                                                                    </TableHeader>
                                                                    <TableHeader>{t('Contact Person')}</TableHeader>
                                                                    <TableHeader>{t('Mobile Number')}</TableHeader>
                                                                    <TableHeader>{t('Email')}</TableHeader>
                                                                    <TableHeader>{t('Price')}</TableHeader>
                                                                    <TableHeader>{t('Status')}</TableHeader>
                                                                    <TableHeader className="text-right">
                                                                        {t('Actions')}
                                                                    </TableHeader>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {shuttleServiceList.map((routeShuttle, index) => {
                                                                    const shuttleService = routeShuttle.shuttle_provider
                                                                    return (
                                                                        <TableRow
                                                                            className="cursor-pointer hover:bg-gray-50"
                                                                            key={routeShuttle.route_shuttle_id}
                                                                        >
                                                                            <TableCell>{index + 1}</TableCell>
                                                                            <TableCell>
                                                                                {shuttleService.provider_name}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {shuttleService.service_description?.en}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {shuttleService.service_description?.ar}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {shuttleService.contact?.person}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {shuttleService.contact?.mobile_number}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {shuttleService.contact?.email}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                {shuttleService.price?.gross}{' '}
                                                                                {shuttleService.price?.currency}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Badge
                                                                                    color={
                                                                                        shuttleService.isactive
                                                                                            ? 'lime'
                                                                                            : 'red'
                                                                                    }
                                                                                >
                                                                                    {shuttleService.isactive
                                                                                        ? t('Active')
                                                                                        : t('Inactive')}
                                                                                </Badge>
                                                                            </TableCell>
                                                                            <TableCell className="text-right">
                                                                                <Dropdown>
                                                                                    <DropdownButton
                                                                                        plain
                                                                                        aria-label="More options"
                                                                                    >
                                                                                        <EllipsisVerticalIcon />
                                                                                    </DropdownButton>
                                                                                    <DropdownMenu anchor="bottom">
                                                                                        <DropdownItem
                                                                                            onClick={() =>
                                                                                                handleToggleShuttleService(
                                                                                                    shuttleService.provider_id,
                                                                                                    shuttleService.isactive
                                                                                                )
                                                                                            }
                                                                                            disabled={
                                                                                                toggleShuttleLoading
                                                                                            }
                                                                                        >
                                                                                            <DropdownLabel>
                                                                                                {shuttleService.isactive
                                                                                                    ? t('Disable')
                                                                                                    : t('Enable')}
                                                                                            </DropdownLabel>
                                                                                        </DropdownItem>
                                                                                    </DropdownMenu>
                                                                                </Dropdown>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* {activeTab === 'assignboat' && (
                                <div className="bg-white flex flex-wrap items-end justify-between gap-4 border border-gray-100 rounded-t-lg overflow-hidden py-6 px-3">
                                    <div className="max-sm:w-full sm:flex-1">
                                        <AssignBoat routeId={id} routeName={routeList[0].route_name?.en} />
                                    </div>
                                </div>
                            )} */}
                        </div>
                    </div>

                    {showMealModal && (
                        <Dialog open={showMealModal} onClose={() => setShowMealModal(false)} className="relative z-50">
                            <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

                            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                    <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                                        <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                            <div className="flex items-center justify-between border-b border-gray-200 pb-4">
                                                <DialogTitle
                                                    as="h3"
                                                    className="text-lg font-semibold leading-6 text-gray-900"
                                                >
                                                    {t('Select Meal to Add')}
                                                </DialogTitle>
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                                                    onClick={() => setShowMealModal(false)}
                                                >
                                                    <XMarkIcon className="h-6 w-6" />
                                                </button>
                                            </div>

                                            {/* Search Section */}
                                            <div className="mt-4 mb-4 flex flex-col sm:flex-row flex-wrap max-w-xl gap-4">
                                                <div className="flex-2">
                                                    <InputGroup>
                                                        <MagnifyingGlassIcon />
                                                        <Input
                                                            value={mealSearchString}
                                                            onChange={e => setMealSearchString(e.target.value)}
                                                            name="mealSearch"
                                                            id="mealSearch"
                                                            placeholder={t('Search meals')}
                                                        />
                                                    </InputGroup>
                                                </div>

                                                <div className="flex gap-2 justify-end">
                                                    <button
                                                        onClick={onMealSearch}
                                                        type="button"
                                                        className="inline-flex items-center justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/[0.9]"
                                                    >
                                                        {t('Search')}
                                                    </button>
                                                    <button
                                                        onClick={onMealSearchClear}
                                                        type="button"
                                                        className="inline-flex items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                    >
                                                        {t('Clear')}
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Meals List */}
                                            <div className="mt-4 max-h-96 overflow-y-auto">
                                                {allMealsLoading && (
                                                    <div className="flex justify-center items-center py-8">
                                                        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
                                                    </div>
                                                )}

                                                {!allMealsLoading && getSelectableMeals().length === 0 && (
                                                    <div className="text-center py-8">
                                                        <p className="text-gray-500">
                                                            {allMealsList?.length === 0
                                                                ? t('No meals found')
                                                                : t('All available meals have been added to this trip')}
                                                        </p>
                                                    </div>
                                                )}

                                                {!allMealsLoading && getSelectableMeals().length > 0 && (
                                                    <div className="grid grid-cols-1 gap-3">
                                                        {getSelectableMeals()
                                                            .filter(meal => meal.active)
                                                            .map(meal => (
                                                                <div
                                                                    key={meal.meal_id}
                                                                    className={`p-4 border rounded-lg cursor-pointer transition-colors ${
                                                                        selectedMealId === meal.meal_id
                                                                            ? 'border-primary bg-primary/5 ring-2 ring-primary'
                                                                            : 'border-gray-200 hover:border-gray-300'
                                                                    }`}
                                                                    onClick={() => {
                                                                        console.log('Meal selected:', meal.meal_id)
                                                                        setSelectedMealId(meal.meal_id)
                                                                    }}
                                                                >
                                                                    <div className="flex items-center justify-between">
                                                                        <div className="flex-1">
                                                                            <div className="flex items-center justify-between mb-2">
                                                                                <h4 className="text-sm font-medium text-gray-900">
                                                                                    {meal.description.en}
                                                                                </h4>
                                                                                {selectedMealId === meal.meal_id && (
                                                                                    <CheckIcon className="h-5 w-5 text-primary" />
                                                                                )}
                                                                            </div>
                                                                            <p className="text-sm text-gray-600 mb-2">
                                                                                {meal.description.ar}
                                                                            </p>
                                                                            <div className="flex items-center justify-between">
                                                                                <span className="text-sm text-gray-700">
                                                                                    {t('Price')}:{' '}
                                                                                    {(
                                                                                        parseFloat(meal.price.base) +
                                                                                        parseFloat(meal.price.tax)
                                                                                    ).toFixed(2)}
                                                                                    ({meal.price.base} +{' '}
                                                                                    {meal.price.tax})
                                                                                </span>
                                                                                <span
                                                                                    className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${
                                                                                        meal.active
                                                                                            ? 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20'
                                                                                            : 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/20'
                                                                                    }`}
                                                                                >
                                                                                    {meal.active
                                                                                        ? t('Active')
                                                                                        : t('Inactive')}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Modal Actions */}
                                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                            <button
                                                type="button"
                                                className="inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/90 sm:ml-3 sm:w-auto disabled:opacity-50"
                                                onClick={() => {
                                                    console.log(
                                                        'Add button clicked, selectedMealId:',
                                                        selectedMealId,
                                                        'addMealLoading:',
                                                        addMealLoading
                                                    )
                                                    handleAddMeal()
                                                }}
                                                disabled={!selectedMealId || addMealLoading}
                                            >
                                                {addMealLoading ? t('Adding...') : t('Add')}
                                            </button>
                                            <button
                                                type="button"
                                                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                                onClick={() => {
                                                    setShowMealModal(false)
                                                    setSelectedMealId('')
                                                    setMealSearchString('')
                                                }}
                                                disabled={addMealLoading}
                                            >
                                                {t('Cancel')}
                                            </button>
                                        </div>
                                    </DialogPanel>
                                </div>
                            </div>
                        </Dialog>
                    )}

                    {/* Luggage Options Modal */}
                    {showLuggageModal && (
                        <Dialog open={showLuggageModal} onClose={() => setShowLuggageModal(false)} className="relative">
                            <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                            <div className="fixed inset-0 w-screen overflow-y-auto">
                                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                    <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                                        <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                            <div className="flex items-center justify-between border-b border-gray-200 pb-4">
                                                <DialogTitle
                                                    as="h3"
                                                    className="text-lg font-semibold leading-6 text-gray-900"
                                                >
                                                    {t('Select Luggage to Add')}
                                                </DialogTitle>
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                                                    onClick={() => setShowLuggageModal(false)}
                                                >
                                                    <XMarkIcon className="h-6 w-6" />
                                                </button>
                                            </div>

                                            {/* Search Section */}
                                            <div className="mt-4 mb-4 flex flex-col sm:flex-row flex-wrap max-w-xl gap-4">
                                                <div className="flex-2">
                                                    <InputGroup>
                                                        <MagnifyingGlassIcon />
                                                        <Input
                                                            value={luggageSearchString}
                                                            onChange={e => setLuggageSearchString(e.target.value)}
                                                            name="luggageSearch"
                                                            id="luggageSearch"
                                                            placeholder={t('Search luggages')}
                                                        />
                                                    </InputGroup>
                                                </div>

                                                <div className="flex gap-2 justify-end">
                                                    <button
                                                        onClick={onLuggageSearch}
                                                        type="button"
                                                        className="inline-flex items-center justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/[0.9]"
                                                    >
                                                        {t('Search')}
                                                    </button>
                                                    <button
                                                        onClick={onLuggageSearchClear}
                                                        type="button"
                                                        className="inline-flex items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                    >
                                                        {t('Clear')}
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Luggages List */}
                                            <div className="mt-4 max-h-96 overflow-y-auto">
                                                {allLuggagesLoading && (
                                                    <div className="flex justify-center items-center py-8">
                                                        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
                                                    </div>
                                                )}

                                                {!allLuggagesLoading && getSelectableLuggages().length === 0 && (
                                                    <div className="text-center py-8">
                                                        <p className="text-gray-500">
                                                            {allLuggagesList?.length === 0
                                                                ? t('No luggages found')
                                                                : t(
                                                                      'All available luggages have been added to this trip'
                                                                  )}
                                                        </p>
                                                    </div>
                                                )}

                                                {!allLuggagesLoading && getSelectableLuggages().length > 0 && (
                                                    <div className="grid grid-cols-1 gap-3">
                                                        {getSelectableLuggages()
                                                            .filter(luggage => luggage.active)
                                                            .map(luggage => (
                                                                <div
                                                                    key={luggage.luggage_id}
                                                                    className={`p-4 border rounded-lg cursor-pointer transition-colors ${
                                                                        selectedLuggageId === luggage.luggage_id
                                                                            ? 'border-primary bg-primary/5 ring-2 ring-primary'
                                                                            : 'border-gray-200 hover:border-gray-300'
                                                                    }`}
                                                                    onClick={() => {
                                                                        console.log(
                                                                            'Luggage selected:',
                                                                            luggage.luggage_id
                                                                        )
                                                                        setSelectedLuggageId(luggage.luggage_id)
                                                                    }}
                                                                >
                                                                    <div className="flex items-center justify-between">
                                                                        <div className="flex-1">
                                                                            <div className="flex items-center justify-between">
                                                                                <span className="text-sm text-gray-1000">
                                                                                    {t('Luggage Type')}:{' '}
                                                                                    {luggage.metadata.luggage_type}
                                                                                </span>
                                                                                <span className="text-sm text-gray-1000">
                                                                                    {luggage.metadata.seat_type ===
                                                                                    'VIP'
                                                                                        ? 'VIP'
                                                                                        : 'Standard'}
                                                                                </span>
                                                                                <span className="text-sm text-gray-1000">
                                                                                    {t('Weight')}: {luggage.weight}
                                                                                </span>
                                                                                <span className="text-sm text-gray-1000">
                                                                                    {t('Luggage Category')}:{' '}
                                                                                    {luggage.metadata.category}
                                                                                </span>
                                                                                <span className="text-sm text-gray-1000">
                                                                                    {t('Price')}:{' '}
                                                                                    {parseFloat(
                                                                                        luggage.price.base
                                                                                    ).toFixed(2)}
                                                                                </span>
                                                                                <span
                                                                                    className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ${
                                                                                        luggage.active
                                                                                            ? 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20'
                                                                                            : 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/20'
                                                                                    }`}
                                                                                >
                                                                                    {luggage.active
                                                                                        ? t('Active')
                                                                                        : t('Inactive')}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Modal Actions */}
                                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                            <button
                                                type="button"
                                                className="inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/90 sm:ml-3 sm:w-auto disabled:opacity-50"
                                                onClick={() => {
                                                    console.log(
                                                        'Add button clicked, selectedLuggageId:',
                                                        selectedLuggageId,
                                                        'addLuggageLoading:',
                                                        addLuggageLoading
                                                    )
                                                    handleAddLuggage()
                                                }}
                                                disabled={!selectedLuggageId || addLuggageLoading}
                                            >
                                                {addLuggageLoading ? t('Adding...') : t('Add')}
                                            </button>
                                            <button
                                                type="button"
                                                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                                onClick={() => {
                                                    setShowLuggageModal(false)
                                                    setSelectedLuggageId('')
                                                    setLuggageSearchString('')
                                                }}
                                                disabled={addLuggageLoading}
                                            >
                                                {t('Cancel')}
                                            </button>
                                        </div>
                                    </DialogPanel>
                                </div>
                            </div>
                        </Dialog>
                    )}

                    {/* Shuttle Service Selection Modal */}
                    {showShuttleModal && (
                        <Dialog
                            open={showShuttleModal}
                            onClose={() => setShowShuttleModal(false)}
                            className="relative z-50"
                        >
                            <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                    <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                                        <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                            <div className="flex items-center justify-between border-b border-gray-200 pb-4">
                                                <DialogTitle
                                                    as="h3"
                                                    className="text-lg font-semibold leading-6 text-gray-900"
                                                >
                                                    {t('Select Shuttle Service to Add')}
                                                </DialogTitle>
                                                <button
                                                    type="button"
                                                    className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                                                    onClick={() => setShowShuttleModal(false)}
                                                >
                                                    <XMarkIcon className="h-6 w-6" />
                                                </button>
                                            </div>

                                            {/* Search Section */}
                                            <div className="mt-4 mb-4 flex flex-col sm:flex-row flex-wrap max-w-xl gap-4">
                                                <div className="flex-2">
                                                    <InputGroup>
                                                        <MagnifyingGlassIcon />
                                                        <Input
                                                            value={shuttleSearchString}
                                                            onChange={e => setShuttleSearchString(e.target.value)}
                                                            name="shuttleSearch"
                                                            id="shuttleSearch"
                                                            placeholder={t('Search shuttle services')}
                                                        />
                                                    </InputGroup>
                                                </div>

                                                <div className="flex gap-2 justify-end">
                                                    <button
                                                        onClick={onShuttleSearch}
                                                        type="button"
                                                        className="inline-flex items-center justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/[0.9]"
                                                    >
                                                        {t('Search')}
                                                    </button>
                                                    <button
                                                        onClick={onShuttleSearchClear}
                                                        type="button"
                                                        className="inline-flex items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                                    >
                                                        {t('Clear')}
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Shuttle Services List */}
                                            <div className="mt-4 max-h-96 overflow-y-auto overflow-x-hidden">
                                                {allShuttleServicesLoading && (
                                                    <div className="flex justify-center items-center py-8">
                                                        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
                                                    </div>
                                                )}

                                                {!allShuttleServicesLoading &&
                                                    getSelectableShuttleServices().length === 0 && (
                                                        <div className="text-center py-8">
                                                            <p className="text-gray-500">
                                                                {allShuttleServices?.length === 0
                                                                    ? t('No shuttle services found')
                                                                    : t(
                                                                          'All available shuttle services have been added to this route'
                                                                      )}
                                                            </p>
                                                        </div>
                                                    )}

                                                {!allShuttleServicesLoading &&
                                                    getSelectableShuttleServices().length > 0 && (
                                                        <div className="grid grid-cols-1 gap-3 pr-2">
                                                            {getSelectableShuttleServices().map(shuttle => (
                                                                <div
                                                                    key={shuttle.provider_id}
                                                                    className={`relative border-2 rounded-lg cursor-pointer transition-all duration-200 shadow-sm hover:shadow-md ${
                                                                        selectedShuttleId === shuttle.provider_id
                                                                            ? 'border-primary bg-primary/5 shadow-lg'
                                                                            : 'border-gray-200 hover:border-primary/30 bg-white'
                                                                    }`}
                                                                    onClick={() => {
                                                                        console.log(
                                                                            'Shuttle service selected:',
                                                                            shuttle.provider_id
                                                                        )
                                                                        setSelectedShuttleId(shuttle.provider_id)
                                                                    }}
                                                                >
                                                                    {/* Selection indicator */}
                                                                    {selectedShuttleId === shuttle.provider_id && (
                                                                        <div className="absolute top-2 right-2 z-10">
                                                                            <div className="bg-primary rounded-full p-1 shadow-lg">
                                                                                <CheckIcon className="h-4 w-4 text-white" />
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    <div className="p-4">
                                                                        {/* Header with provider name, status, and price */}
                                                                        <div className="flex items-center justify-between mb-3">
                                                                            <div className="flex-1 pr-4">
                                                                                <div className="flex items-center gap-3 mb-2">
                                                                                    <h4 className="text-base font-semibold text-gray-900">
                                                                                        {shuttle.provider_name}
                                                                                    </h4>
                                                                                    <span
                                                                                        className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
                                                                                            shuttle.isactive
                                                                                                ? 'bg-green-100 text-green-800'
                                                                                                : 'bg-red-100 text-red-800'
                                                                                        }`}
                                                                                    >
                                                                                        {shuttle.isactive
                                                                                            ? t('Active')
                                                                                            : t('Inactive')}
                                                                                    </span>
                                                                                </div>

                                                                                {/* Service descriptions in one line */}
                                                                                <div className="text-sm text-gray-600 space-y-1">
                                                                                    {shuttle.service_description
                                                                                        ?.en && (
                                                                                        <p className="truncate">
                                                                                            <span className="font-medium">
                                                                                                EN:
                                                                                            </span>{' '}
                                                                                            {
                                                                                                shuttle
                                                                                                    .service_description
                                                                                                    .en
                                                                                            }
                                                                                        </p>
                                                                                    )}
                                                                                    {shuttle.service_description
                                                                                        ?.ar && (
                                                                                        <p
                                                                                            className="truncate"
                                                                                            dir="rtl"
                                                                                        >
                                                                                            <span className="font-medium">
                                                                                                AR:
                                                                                            </span>{' '}
                                                                                            {
                                                                                                shuttle
                                                                                                    .service_description
                                                                                                    .ar
                                                                                            }
                                                                                        </p>
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                            <div className="text-right flex-shrink-0">
                                                                                <p className="text-lg font-bold text-primary">
                                                                                    {shuttle.price?.gross}{' '}
                                                                                    <span className="text-sm font-normal text-gray-600">
                                                                                        {shuttle.price?.currency}
                                                                                    </span>
                                                                                </p>
                                                                            </div>
                                                                        </div>

                                                                        {/* Contact information in compact format */}
                                                                        <div className="flex flex-wrap gap-4 text-xs text-gray-600 pt-2 border-t border-gray-100">
                                                                            {shuttle.contact?.person && (
                                                                                <span>
                                                                                    <span className="font-medium">
                                                                                        {t('Contact')}:
                                                                                    </span>{' '}
                                                                                    {shuttle.contact.person}
                                                                                </span>
                                                                            )}
                                                                            {shuttle.contact?.mobile_number && (
                                                                                <span>
                                                                                    <span className="font-medium">
                                                                                        {t('Mobile')}:
                                                                                    </span>{' '}
                                                                                    {shuttle.contact.mobile_number}
                                                                                </span>
                                                                            )}
                                                                            {shuttle.contact?.email && (
                                                                                <span className="truncate max-w-48">
                                                                                    <span className="font-medium">
                                                                                        {t('Email')}:
                                                                                    </span>{' '}
                                                                                    {shuttle.contact.email}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                            </div>
                                        </div>

                                        {/* Modal Actions */}
                                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                            <button
                                                type="button"
                                                className="inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/90 sm:ml-3 sm:w-auto disabled:opacity-50"
                                                onClick={() => {
                                                    console.log(
                                                        'Add button clicked, selectedShuttleId:',
                                                        selectedShuttleId,
                                                        'addShuttleLoading:',
                                                        addShuttleLoading
                                                    )
                                                    handleAddShuttleService()
                                                }}
                                                disabled={!selectedShuttleId || addShuttleLoading}
                                            >
                                                {addShuttleLoading ? t('Adding...') : t('Add')}
                                            </button>
                                            <button
                                                type="button"
                                                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                                onClick={() => {
                                                    setShowShuttleModal(false)
                                                    setSelectedShuttleId('')
                                                    setShuttleSearchString('')
                                                }}
                                                disabled={addShuttleLoading}
                                            >
                                                {t('Cancel')}
                                            </button>
                                        </div>
                                    </DialogPanel>
                                </div>
                            </div>
                        </Dialog>
                    )}

                    {/* Shuttle Service Confirmation Dialog */}
                    {showShuttleConfirmDialog && shuttleToToggle && (
                        <Dialog
                            open={showShuttleConfirmDialog}
                            onClose={() => setShowShuttleConfirmDialog(false)}
                            className="relative z-50"
                        >
                            <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                            <div className="fixed inset-0 z-10 overflow-y-auto">
                                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                    <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                        <div>
                                            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100">
                                                <svg
                                                    className="h-6 w-6 text-yellow-600"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth="1.5"
                                                    stroke="currentColor"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                                                    />
                                                </svg>
                                            </div>
                                            <div className="mt-3 text-center sm:mt-5">
                                                <DialogTitle
                                                    as="h3"
                                                    className="text-lg font-semibold leading-6 text-gray-900"
                                                >
                                                    {shuttleToToggle.newStatus
                                                        ? t('Enable Shuttle Service')
                                                        : t('Disable Shuttle Service')}
                                                </DialogTitle>
                                                <div className="mt-2">
                                                    <p className="text-sm text-gray-500">
                                                        {shuttleToToggle.newStatus
                                                            ? t('Are you sure you want to enable this shuttle service?')
                                                            : t(
                                                                  'Are you sure you want to disable this shuttle service?'
                                                              )}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                            <button
                                                type="button"
                                                className="inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary/90 sm:col-start-2 disabled:opacity-50"
                                                onClick={confirmToggleShuttleService}
                                                disabled={toggleShuttleLoading}
                                            >
                                                {toggleShuttleLoading ? t('Processing...') : t('Confirm')}
                                            </button>
                                            <button
                                                type="button"
                                                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                                                onClick={() => {
                                                    setShowShuttleConfirmDialog(false)
                                                    setShuttleToToggle(null)
                                                }}
                                                disabled={toggleShuttleLoading}
                                            >
                                                {t('Cancel')}
                                            </button>
                                        </div>
                                    </DialogPanel>
                                </div>
                            </div>
                        </Dialog>
                    )}

                    {(submitLoading ||
                        addMealLoading ||
                        removeMealLoading ||
                        addLuggageLoading ||
                        enableDisableLuggageLoading ||
                        addShuttleLoading ||
                        toggleShuttleLoading) && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"></div>
                        </div>
                    )}
                    {showErrDialog && (
                        <ErrorDialog status={true} title="Error" message={errorMessage} onClose={handleErrClose} />
                    )}
                    {showSucDialog && (
                        <SuccessDialog
                            status={true}
                            title={t('Success')}
                            message={t('Updated Successfully')}
                            onClose={handleSuccessDialogClose}
                        />
                    )}
                </>
            )}
        </>
    )
}
